<template>
  <v-container
    :class="{ 'pa-0': $vuetify.breakpoint.smAndDown }"
  >
    <v-navigation-drawer
      v-if="isAuthorized === true && agent"
      app
      right
    >
      <v-list three-line>
        <template v-for="(item, index) in log">
          <v-list-item
            :key="item.logTimeStamp"
            ripple
          >
            <v-list-item-content>
              <v-list-item-subtitle class="text-caption">
                {{ formatDateTime(item.logTimestamp) }}
              </v-list-item-subtitle>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider
            v-if="index + 1 < log.length"
            :key="index"
          />
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-card v-if="loadingThings" class="elevation-0 pa-12">
      <h2>Odota hetki</h2>
      <v-progress-linear :indeterminate="true"/>
    </v-card>
    <v-card v-else-if="expired" class="pa-5">
      <v-layout row>
        <v-icon color="primary" size="56">
          notification_important
        </v-icon>
        <div class="ml-3">
          <h1>
            Istunto päättynyt
          </h1>
          <p class="mt-1">
            Olet avannut toisen ostotarjouksen, tai istunto on päättynyt jostakin muusta syystä.<br>
            Voit muokata vain yhtä ostotarjousta kerrallaan!
          </p>
        </div>
      </v-layout>
    </v-card>
    <div v-else class="grid">
      <v-card
        :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : 'pa-0'"
        style="max-width: 1000px;"
        class="helmi-card"
      >
        <v-card-text
          v-if="isAuthorized === false && thankyou === false && authorizing === false"
        >
          <div class="py-1">
            <div class="helmi-card-title">
              Sähköinen ostotarjous
            </div>
            <p>Syötä pääsykoodi kirjautuaksesi sisään.</p>
          </div>
          <v-form
            @submit.prevent="submitCode()"
          >
            <v-text-field
              v-model="passCode"
              class="mt-3 mb-1"
              type="password"
              outlined
              hide-details
              append-icon="lock"
              label="Pääsykoodi"
            />
            <v-checkbox
              v-model="acceptGdpr"
              hide-details
              class="mt-3"
              label="Hyväksyn henkilötietojeni sähköisen käsittelyn"
            />
            <p class="text-caption mt-2">
              Tarjousmenettely edellyttää henkilötietojen automaattista käsittelyä ja tietojen
              tallennusta asiakasrekisteriimme.
              <a @click="showGdpr = true">
                EU:n tietosuoja-asetuksen (GDPR) mukainen tietosuojaseloste.
              </a>
            </p>
            <v-dialog v-model="showGdpr" max-width="600">
              <gdpr/>
            </v-dialog>
            <div class="grid grid-actions">
              <v-btn
                :disabled="!codeValid || !acceptGdpr"
                color="primary"
                type="submit"
              >
                Ok
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
        <v-card-text v-else-if="thankyou" class="mt-10 pa-8 elevation-10">
          <v-row>
            <v-icon color="primary" size="56">
              check
            </v-icon>
            <div class="ml-3">
              <h1>
                Tarjous lähetetty!
              </h1>
              <p class="mt-2 mb-0">
                Odota hetki niin tarjous latautuu PDF-tiedostona.
              </p>
              <p v-if="thankYouRole === 'offerer'">
                Tarjous on välitetty myyjälle ja välittäjällesi.
              </p>
              <p v-else>
                Vastaus on välitetty tarjoajalle ja välittäjällesi.
              </p>
            </div>
          </v-row>
        </v-card-text>
        <v-card-text
          v-else-if="thankyou === false &&
            edit && loadingThings === false && (form.status === 'new' || form.status === 'fill')"
          class="pa-0"
        >
          <div class="px-3">
            <div class="helmi-card-title mb-3 mt-1">
              Sähköinen ostotarjous
            </div>

            <v-expansion-panels :value="panel">
              <v-expansion-panel>
                <v-expansion-panel-header
                  :hide-actions="$vuetify.breakpoint.smAndDown"
                >
                  <v-row align="center">
                    <v-avatar
                      :class="$vuetify.breakpoint.smAndDown ? 'ml-1' : 'ml-3'"
                      class="cyan darken-2 white--text text-caption"
                      size="24"
                    >
                      1
                    </v-avatar>
                    <div
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'text-caption ml-2'
                          : 'text-body-2 ml-4'
                      "
                    >
                      Tarjouksen kohde
                    </div>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p v-if="isShare" class="my-4">
                    <b>Taloyhtiön nimi:</b> {{ property.yhtionimi }}<br>
                    <b>Osoite:</b> {{ property.kohdenimi }},
                    {{ property.postinumero }} {{ property.kaupunki }}<br>
                    <b>Huoneiston numero:</b> {{ property.huoneistonro }}<br>
                    <b>Osakkeiden / osuuksien numerot:</b>
                    {{ property.osakealku }} - {{ property.osakeloppu }}
                    <template v-if="property.add_share !== ''">
                      ja {{ property.add_share }} - {{ property.add_share2 }}
                    </template><br>
                  </p>
                  <p v-else class="my-4">
                    <b>Tyyppi:</b> {{ propertyType === 2 ? 'Vuokraoikeus' : 'Kiinteistö' }}<br>
                    <b>Osoite:</b> {{ property.kohdenimi }},
                    {{ property.postinumero }} {{ property.kaupunki }}<br>
                    <b>Kiinteistötunnus<span v-if="propertyType === 2">/laitostunnus</span>:</b>
                    {{ property.omkkiinteistotunnus }}
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header
                  :hide-actions="$vuetify.breakpoint.smAndDown"
                >
                  <v-row align="center">
                    <v-avatar
                      :class="$vuetify.breakpoint.smAndDown ? 'ml-1' : 'ml-3'"
                      class="cyan darken-2 white--text text-caption"
                      size="24"
                    >
                      2
                    </v-avatar>
                    <div
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'text-caption ml-2'
                          : 'text-body-2 ml-4'
                      "
                    >
                      Tarjouksen tekijät
                    </div>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list rounded class="mt-4">
                    <v-list-item-group color="primary">
                      <v-menu
                        v-for="(item, index) in form.offerers"
                        :key="index"
                        offset-y
                      >
                        <template v-slot:activator="{ on }">
                          <v-list-item
                            class="grey lighten-4"
                            v-on="on"
                          >
                            <v-list-item-icon class="mr-4">
                              <v-icon class="primary--text my-1" large>
                                account_circle
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="primary--text">
                                {{ item.isCompany ? item.companyName : item.name }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                {{ item.email }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle v-if="!item.isCompany">
                                {{ item.assetTransfer ? 'Ei varainsiirtoverovelvollinen' :
                                  'Varainsiirtoverovelvollinen' }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle v-else>
                                Edustaja: {{ item.name }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle v-if="!oldVersion">
                                PEP: {{ item.pep ? 'Kyllä' : 'Ei' }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <v-list>
                          <v-list-item @click="editOfferer(index)">
                            <v-list-item-title>Muokkaa</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="removeOfferer(index)">
                            <v-list-item-title>Poista</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-group>
                  </v-list>
                  <v-alert
                    v-if="duplicates.offerers"
                    class="mx-4"
                    type="warning"
                    dense
                    text
                  >
                    Tarjoajilla tulee olla eri sähköpostiosoitteet
                  </v-alert>
                  <v-dialog
                    v-model="dialog"
                    :fullscreen="$vuetify.breakpoint.smAndDown"
                    width="550"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        class="ml-3 mt-2"
                        large
                        v-on="on"
                      >
                        Lisää tarjoaja
                        <v-icon right dark>
                          person_add
                        </v-icon>
                      </v-btn>
                    </template>
                    <offerer-form
                      :new-person="newPerson"
                      :form="form"
                      :indexes="indexes"
                      :editing="editing"
                      :duplicates="duplicates"
                    />
                  </v-dialog>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header
                  :hide-actions="$vuetify.breakpoint.smAndDown"
                >
                  <v-row align="center">
                    <v-avatar
                      :class="$vuetify.breakpoint.smAndDown ? 'ml-1' : 'ml-3'"
                      class="cyan darken-2 white--text text-caption"
                      size="24"
                    >
                      3
                    </v-avatar>
                    <div
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'text-caption ml-2'
                          : 'text-body-2 ml-4'
                      "
                    >
                      Kauppasumma<span v-if="isShare">, velkaosuus</span> ja maksutapa
                    </div>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <h3 class="mt-4">
                    3.1 Kauppasumma<span v-if="isShare"> ja velkaosuus</span>
                  </h3>
                  <p v-if="isShare">
                    Tämän huoneiston velaton hintapyyntö on
                    <b>{{ property.vhinta && property.vhinta.replace('.', ',') }} €</b>
                  </p>
                  <p v-else>
                    Tämän kiinteistön hintapyyntö on
                    <b>{{ property.hinta && property.hinta.replace('.', ',') }} €</b>
                  </p>
                  <v-text-field
                    v-if="isShare"
                    v-model="form.offer"
                    class="mt-2 mb-3"
                    outlined
                    append-icon="euro_symbol"
                    label="Velaton tarjoussumma"
                    hint="Sisältää mahdollisen huoneistokohtaisen velkaosuuden"
                    persistent-hint
                    type="number"
                    :disabled="signaturesExist"
                    @change="countDeposit()"
                  />
                  <v-text-field
                    v-else
                    v-model="form.offer"
                    class="mt-2 mb-3"
                    outlined
                    append-icon="euro_symbol"
                    label="Tarjoussumma"
                    persistent-hint
                    type="number"
                    :disabled="signaturesExist"
                    @change="countDeposit()"
                  />

                  <v-alert
                    v-if="isShare"
                    :icon="$vuetify.breakpoint.smAndDown ? false : 'info'"
                    prominent
                    text
                    color="blue"
                  >
                    <p class="text-caption">
                      Isännöitsijäntodistuksen mukainen velkaosuus: <b>{{ form.debt }} euroa</b>
                      <br>
                      Isännöitsijäntodistuksen päivämäärä: {{ debtDateFormatted }}.
                      {{ debtDateAddText }}
                    </p>
                    <p class="text-caption mb-0">
                      {{ debtPartText }}
                    </p>
                  </v-alert>
                  <v-radio-group
                    v-if="isShare"
                    v-model="form.debtPortionPayer"
                  >
                    <v-radio
                      v-for="(n, index) in form.debtPortionPayers"
                      :key="index"
                      :label="n.text"
                      :value="n.value"
                      :disabled="signaturesExist"
                      color="primary"
                    />
                  </v-radio-group>
                  <v-slide-y-transition>
                    <p
                      v-if="form.debtPortionPayer === 2"
                      class="text-caption mb-4"
                    >
                      Velkaosuutta ei makseta pois kaupantekotilaisuudessa. Ostaja ottaa
                      huoneistokohtaisen velkaosuuden vastattavakseen. Mikäli lainaosuuden
                      määrä on muuttunut edellä mainitusta, muuttuu maksettavan kauppasumman
                      määrä niin, että hyväksytty velaton kauppahinta pysyy
                      samana. Lainaosuuden määrä pyritään tarkastamaan kaupantekopäivälle.
                    </p>
                  </v-slide-y-transition>
                  <div v-if="isShare">
                    <h3 class="mt-1">
                      3.2 Myyntihinta
                    </h3>
                    <p>{{ sellingPrice ? sellingPrice.toString().replace('.', ',') : '0' }} €</p>
                  </div>
                  <h3 class="mt-1">
                    3.{{ isShare ? '3' : '2' }} Maksutapa ja maksuaikataulu
                  </h3>
                  <v-radio-group
                    v-model="form.paymentMethod"
                  >
                    <v-radio
                      v-for="(n, index) in form.paymentMethods"
                      :key="index"
                      :label="n"
                      :value="n"
                      :disabled="signaturesExist"
                      color="primary"
                    />
                  </v-radio-group>
                  <template v-if="form.paymentMethod === 'Osamaksu'">
                    <v-text-field
                      v-model="form.paymentDetail"
                      :disabled="signaturesExist"
                      label="Kaupanteon yhteydessä maksetaan"
                      outlined
                      append-icon="euro_symbol"
                      type="number"
                    />
                    <v-menu
                      v-model="datePickerMenu2"
                      :disabled="signaturesExist"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="paymentDateFormatted"
                          outlined
                          label="Loppuosa maksetaan"
                          append-icon="event"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="form.paymentDate"
                        first-day-of-week="1"
                        locale="fi-FI"
                        @input="datePickerMenu2 = false"
                      />
                    </v-menu>
                  </template>
                  <v-text-field
                    v-if="form.paymentMethod === 'Muu (anna selite)'"
                    v-model="form.paymentOther"
                    :disabled="signaturesExist"
                    label="Maksun selite"
                    maxlength="100"
                    counter="100"
                    outlined
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header
                  :hide-actions="$vuetify.breakpoint.smAndDown"
                >
                  <v-row align="center">
                    <v-avatar
                      :class="$vuetify.breakpoint.smAndDown ? 'ml-1' : 'ml-3'"
                      class="cyan darken-2 white--text text-caption"
                      size="24"
                    >
                      4
                    </v-avatar>
                    <div
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'text-caption ml-2'
                          : 'text-body-2 ml-4'
                      "
                    >
                      Oikeuksien<span v-if="!isShare"> ja velvollisuuksien</span> siirtyminen
                    </div>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <h3 class="mt-4">
                    4.1 Omistusoikeuden siirtyminen
                  </h3>
                  <v-radio-group
                    v-model="form.ownershipTransfer"
                  >
                    <v-radio
                      v-for="(n, index) in filteredOwnershipTransfers"
                      :key="index"
                      :label="n.text"
                      :value="n.value"
                      :disabled="signaturesExist"
                      color="primary"
                    />
                  </v-radio-group>
                  <v-text-field
                    v-if="form.ownershipTransfer === 1"
                    v-model="form.ownershipTransferDetail"
                    :disabled="signaturesExist"
                    label="Omistusoikeuden siirtymisen selite"
                    outlined
                  />
                  <h3 class="mt-3">
                    4.2 Hallintaoikeuden siirtyminen
                  </h3>
                  <v-radio-group
                    v-model="form.possessionTransfer"
                  >
                    <v-radio
                      v-for="(n, index) in form.possessionTransfers"
                      :key="index"
                      :label="n.text"
                      :value="n.value"
                      :disabled="signaturesExist"
                      color="primary"
                    />
                  </v-radio-group>
                  <v-text-field
                    v-if="form.possessionTransfer === 1"
                    v-model="form.possessionTransferDetail"
                    :disabled="signaturesExist"
                    label="Hallintaoikeuden siirtymisen selite"
                    outlined
                  />
                  <h3 class="mt-3">
                    4.3 Viivästyskorvaus
                  </h3>
                  <p>
                    Mikäli vapautuminen viivästyy myyjästä johtuvasta syystä,
                    myyjä maksaa viivästyskorvauksen.
                  </p>
                  <v-text-field
                    v-model="form.paymentDelay"
                    :disabled="signaturesExist"
                    label="Viivästysmaksu kultakin alkaneelta viivästysviikolta"
                    append-icon="euro_symbol"
                    outlined
                    type="number"
                  />
                  <h3 class="mt-3">
                    4.4 Vastuu maksuista
                  </h3>
                  <p v-if="isShare">
                    Yhtiövastikkeista, yhtiölle suoritettavista maksuista ja muista
                    huoneistoon kohdistuvista maksuista vastaa ostaja:
                  </p>
                  <p v-else>
                    Kiinteistön ylläpitokustannuksista vastaa ostaja:
                  </p>
                  <v-radio-group
                    v-model="form.expense"
                  >
                    <v-radio
                      v-for="(n, index) in form.expenses"
                      :key="index"
                      :disabled="signaturesExist"
                      :label="n.text"
                      :value="n.value"
                      color="primary"
                    />
                  </v-radio-group>
                  <v-text-field
                    v-if="form.expense === 1"
                    v-model="form.expenseDetail"
                    label="Maksujen selite"
                    outlined
                  />
                  <div v-if="!isShare">
                    <h3 class="mt-3">
                      4.5 Vaaranvastuun siirtyminen ostajalle
                    </h3>
                    <v-radio-group
                      v-model="form.risk"
                    >
                      <v-radio
                        v-for="(n, index) in form.risks"
                        :key="index"
                        :disabled="signaturesExist"
                        :label="n.text"
                        :value="n.value"
                        color="primary"
                      />
                    </v-radio-group>
                    <v-text-field
                      v-if="form.risk === 1"
                      v-model="form.riskDetail"
                      label="Vaaranvastuun muu selite"
                      outlined
                    />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header
                  :hide-actions="$vuetify.breakpoint.smAndDown"
                >
                  <v-row align="center">
                    <v-avatar
                      :class="$vuetify.breakpoint.smAndDown ? 'ml-1' : 'ml-3'"
                      class="cyan darken-2 white--text text-caption"
                      size="24"
                    >
                      5
                    </v-avatar>
                    <div
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'text-caption ml-2'
                          : 'text-body-2 ml-4'
                      "
                    >
                      Tarjouksen ehdot
                    </div>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <h3 class="mt-4">
                    5.1 Vastuunrajoituslausekkeet
                  </h3>
                  <v-checkbox
                    v-model="form.conditions.loan"
                    :disabled="signaturesExist"
                    label="Lainan saanti"
                  />
                  <v-checkbox
                    v-model="form.conditions.sell"
                    :disabled="signaturesExist"
                    class="mt-0"
                    label="Oman asunnon myynti"
                  />
                  <v-checkbox
                    v-model="form.conditions.permit"
                    :disabled="signaturesExist"
                    class="mt-0"
                    label="Viranomaisen lupa"
                  />
                  <v-checkbox
                    v-if="form.conditions.condition"
                    v-model="form.conditions.condition"
                    :disabled="signaturesExist"
                    class="mt-0 mb-0"
                    label="Kosteusmittaus / kuntotarkastus"
                  />
                  <v-checkbox
                    v-model="form.conditions.humidity"
                    :disabled="signaturesExist"
                    class="mt-0 mb-0"
                    label="Kosteusmittaus"
                  />
                  <v-checkbox
                    v-model="form.conditions.conditiononly"
                    :disabled="signaturesExist"
                    class="mt-0 mb-0"
                    label="Kuntotarkastus"
                  />
                  <v-scroll-y-transition mode="out-in">
                    <p
                      v-if="form.conditions.condition"
                      :disabled="signaturesExist"
                      class="mb-4 text-caption"
                    >
                      {{ ifOccurs }}
                    </p>
                  </v-scroll-y-transition>
                  <v-divider/>
                  <v-checkbox
                    v-model="form.conditions.marketing"
                    :disabled="signaturesExist"
                    class="mt-3"
                    label="Kohde pysyy markkinoinnissa ja myyjällä on oikeus hyväksyä kolmannen
                    osapuolen tarjous ilman sanktioita"
                  />
                  <h3 class="mt-1">
                    5.2 Varainsiirtovero
                  </h3>
                  <ul class="mt-3 mb-4">
                    <li
                      v-for="(offerer, index) in form.offerers"
                      :key="index"
                    >
                      <template v-if="offerer.isCompany">
                        {{ offerer.companyName }} maksaa varainsiirtoveron
                        <span v-if="isShare"> kaupantekotilaisuudessa</span>
                      </template>
                      <template v-else>
                        {{ offerer.name }}
                        <span v-if="offerer.assetTransfer">
                          ei ole varainsiirtoverovelvollinen
                        </span>
                        <span v-else>
                          maksaa varainsiirtoveron
                          <span v-if="isShare"> kaupantekotilaisuudessa</span>
                        </span>
                      </template>
                    </li>
                  </ul>
                  <v-alert
                    type="info"
                    text
                    prominent
                    dense
                  >
                    Varainsiirtoveroon liittyvät määritykset tehdään kohdassa 2.
                  </v-alert>
                  <h3 class="mt-3">
                    5.3 Muut ehdot
                  </h3>
                  <v-textarea
                    v-model="form.otherConditions"
                    :disabled="signaturesExist"
                    maxlength="1000"
                    counter="1000"
                    class="mt-3 mb-3"
                    outlined
                    :hint="aboutConditions"
                    persistent-hint
                    name="otherConditions"
                    label="Muut ehdot"
                  />
                  <template v-if="!oldVersion">
                    <h3 class="mt-3 mb-4">
                      5.4 Liitteet
                    </h3>
                    <v-chip
                      v-for="(item, idxx) in attachments"
                      :key="idxx"
                      class="mb-2 mx-1"
                      small
                      color="primary"
                      @click="selectAttachment(item)"
                    >
                      {{ item }}
                    </v-chip>
                    <v-textarea
                      v-model="form.selectedAttachments"
                      label="Liitteet"
                      outlined
                    />
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header
                  :hide-actions="$vuetify.breakpoint.smAndDown"
                >
                  <v-row align="center">
                    <v-avatar
                      :class="$vuetify.breakpoint.smAndDown ? 'ml-1' : 'ml-3'"
                      class="cyan darken-2 white--text text-caption"
                      size="24"
                    >
                      6
                    </v-avatar>
                    <div
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'text-caption ml-2'
                          : 'text-body-2 ml-4'
                      "
                    >
                      Vakiokorvaus tai maksettu käsiraha
                      <span v-if="!isShare">ja korvaus kaupasta vetäytymisestä</span>
                    </div>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-radio-group
                    v-model="form.deposit"
                  >
                    <v-radio
                      v-for="(n, index) in form.depositValues"
                      :key="index"
                      :disabled="signaturesExist"
                      :label="n"
                      :value="n"
                      color="primary"
                    />
                  </v-radio-group>
                  <v-text-field
                    v-model="form.depositInEuros"
                    :label="form.deposit"
                    :disabled="signaturesExist"
                    persistent-hint
                    :hint="`${
                      form.deposit === 'Vakiokorvaus' ? 'Vakiokorvaukseksi' : 'Käsirahaksi'
                    } lasketaan oletuksena ${ isShare ? '4' :'10' }% tarjotusta kauppahinnasta.`"
                    append-icon="euro_symbol"
                    outlined
                    type="number"
                  />
                  <p
                    v-if="form.deposit === 'Vakiokorvaus'"
                    class="text-caption"
                    style="white-space: pre-line;"
                  >
                    {{ deposit1text }}
                  </p>
                  <p
                    v-if="form.deposit === 'Käsiraha'"
                    class="text-caption"
                    style="white-space: pre-line;"
                  >
                    {{ deposit2text }}
                  </p>

                  <p
                    v-if="propertyType === 0 && !createdAfterLawChange"
                    class="text-caption"
                    style="white-space: pre-line;"
                  >
                    {{ deposit3 }}
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header
                  :hide-actions="$vuetify.breakpoint.smAndDown"
                >
                  <v-row align="center">
                    <v-avatar
                      :class="$vuetify.breakpoint.smAndDown ? 'ml-1' : 'ml-3'"
                      class="cyan darken-2 white--text text-caption"
                      size="24"
                    >
                      7
                    </v-avatar>
                    <div
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'text-caption ml-2'
                          : 'text-body-2 ml-4'
                      "
                    >
                      Tarjouksen voimassaolo
                    </div>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pb-4">
                  <v-container class="pa-0 mt-4 mb-2" grid-list-md>
                    <v-row
                      row
                      wrap
                      class="mt-3"
                    >
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-menu
                          v-model="datePickerMenu6"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :disabled="signaturesExist"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="offerValidUntilDateFormatted"
                              :disabled="signaturesExist"
                              outlined
                              label="Voimassa päivämäärään asti"
                              append-icon="event"
                              readonly
                              hide-details
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="form.offerValidUntilDate"
                            :disabled="signaturesExist"
                            first-day-of-week="1"
                            locale="fi-FI"
                            @input="datePickerMenu6 = false"
                          />
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          v-model="form.offerValidUntilTime"
                          v-mask="'##:##'"
                          :disabled="signaturesExist"
                          :rules="timeRule"
                          hide-details
                          outlined
                          label="Voimassa kellonaikaan asti"
                          append-icon="access_time"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-menu
                    v-model="datePickerMenu7"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :disabled="signaturesExist"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="signingDateFormatted"
                        :disabled="signaturesExist"
                        readonly
                        label="Kauppakirjat allekirjoitetaan viimeistään"
                        append-icon="event"
                        outlined
                        hide-details
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="form.signingDate"
                      :disabled="signaturesExist"
                      first-day-of-week="1"
                      locale="fi-FI"
                      @input="datePickerMenu7 = false"
                    />
                  </v-menu>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-card-text>
        <v-card-actions
          v-if="edit
            && isAuthorized === true
            && (form.status === 'new' || form.status === 'fill')"
        >
          <v-spacer/>
          <v-btn

            :disabled="duplicates.offerers"
            class="mt-4 ml-2 mb-2"
            color="primary"
            depressed
            large
            @click="next()"
          >
            TALLENNA & ESIKATSELE
          </v-btn>
        </v-card-actions>
        <v-card-text v-if="form.status === 'agreement' && isAuthorized === true" class="pb-0 px-4">
          <h2 class="mt-3">
            Sähköinen ostotarjous
          </h2>
          <p class="mb-0 mt-1">
            Kohteestanne <b>{{ property.kohdenimi }} {{ property.huoneistonro }}</b>
            on tehty sähköinen ostotarjous.
          </p>
        </v-card-text>
        <v-card-text
          v-if="(edit === false || form.status === 'agreement' || form.status === 'decision' ||
            (form.status === 'fill' && edit === false) ||
            form.status === 'filled' ||
            form.status === 'agreed' ||
            form.status === 'declined' ||
            form.status === 'cancelled' ||
            form.status === 'closed' ||
            form.status === 'sellerresponse' || form.status === 'offererresponse') &&
            thankyou === false &&
            isAuthorized === true"
        >
          <div v-if="loadingThings === false">
            <v-card
              :class="$vuetify.breakpoint.smAndDown ? 'pa-1' : 'pa-5'"
              outlined
              class="mb-4"
            >
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="helmi-card-title pb-1">
                    Sähköinen tarjous
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="agent" class="text-caption pt-0">
                    Tarjousmenettely luotu:
                    {{ formatDateTime(createDate ? createDate : new Date(), true) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-card-text v-if="agent" class="pt-2 pb-2">
                <preview-offer
                  :form="form"
                  :property="property"
                  :date="createDate"
                  :is-share="isShare"
                  :deposit-texts="depositTexts"
                  :signatures="signatures"
                  :sign-date="offerSignedDate"
                  :signing-agent="signingAgent"
                />
              </v-card-text>

              <v-card-text v-else class="py-0">
                <p class="mb-1">
                  KOHDE
                </p>
                <p v-if="isShare" class="text-caption">
                  Yhtiön nimi: <span class="primary--text ml-1">{{ property.yhtionimi }}</span><br>
                  Osakkeiden / osuuksien numerot:
                  <span v-if="property.osakeloppu > 0" class="primary--text ml-1">
                    {{ property.osakealku }} - {{ property.osakeloppu }}
                  </span>
                  <template v-if="property.add_share !== ''">
                    ja <span class="primary--text">
                      {{ property.add_share }} - {{ property.add_share2 }}</span>
                  </template><br>
                  Huoneiston osoite ja numero:
                  <span class="primary--text ml-1">
                    {{ property.kohdenimi }} {{ property.huoneistonro }},
                    {{ property.postinumero }} {{ property.kaupunki }}
                  </span>
                </p>
                <p v-else class="text-caption">
                  Kiinteistötunnus<span v-if="propertyType ===2">/laitostunnus</span>:
                  <span class="primary--text ml-1">{{ property.omkkiinteistotunnus }}</span><br>
                  Osoite:
                  <span class="primary--text ml-1">
                    {{ property.kohdenimi }} {{ property.huoneistonro }},
                    {{ property.postinumero }} {{ property.kaupunki }}
                  </span>
                </p>

                <!-- <embed
                  v-if="showPreview"
                  id="pdfPreview"
                  :src="!!pdfDataUrl"
                > -->

                <div v-if="showPreview" id="pdfPreview">
                  <pdf
                    v-for="i in numPages"
                    :key="i"
                    :page="i"
                    :src="pdfDataUrl"
                  />
                </div>

                <v-btn
                  v-if="!showPreview"
                  class="mt-4 mb-2 mr-2"
                  large
                  depressed
                  color="primary"
                  @click="printPdf(false);"
                >
                  Tarjouksen esikatselu
                </v-btn>
                <v-btn
                  class="mt-4 mb-2"
                  large
                  depressed
                  color="primary"
                  @click="printPdf(true)"
                >
                  Lataa PDF
                </v-btn>
              </v-card-text>
            </v-card>

            <v-alert
              v-if="agent"
              prominent
              color="blue"
              :type="$vuetify.breakpoint.smAndDown ? undefined : 'info'"
              text
              class="mt-4"
            >
              <b>LISÄTIEDOT</b><br>
              Tarjouksen tekijä on tietoinen, että mikäli kaupan kohteen hallinnan luovutus
              viivästyy viranomaismääräysten tai -ohjeistusten vuoksi,
              kyseessä ei ole myyjän suoritusvirhe ja tarjouksen tekijä ei tällöin ole oikeutettu
              korvauksiin hallinnan luovutuksen viivästymisen vuoksi.<br>
              Osapuolet ovat tietoisia myös siitä, että mikäli kaupantekotilaisuutta ei pystytä
              järjestämään viranomaismääräysten tai -ohjeistusten
              vuoksi (pankki, välittäjä, ostaja, myyjä) ostotarjouksessa sovitussa ajassa vaan
              se siirtyy myöhempään ajankohtaan, ei tarjouksessa sovittua sanktiota noudateta.
              Osapuolet ovat tietoisia, että mikäli kaupat toteutetaan sähköisesti voi
              kaupankäyntijärjestelmien käytöstä aiheutua kustannuksia.
            </v-alert>

            <v-alert
              v-if="governmentRight && agent"
              prominent
              color="blue"
              :type="$vuetify.breakpoint.smAndDown ? undefined : 'info'"
              text
              class="mt-4"
            >
              <b>VALTION ETUOSTO-OIKEUS</b><br>
              Ostaja on tietoinen siitä, että valtiolla on etuosto-oikeus kiinteistön kaupassa,
              jos kiinteistön hankkiminen on tarpeen maanpuolustuksen, rajavalvonnan tai
              rajaturvallisuuden varmistamiseksi taikka alueellisen koskemattomuuden valvonnan
              ja turvaamisen takia.
            </v-alert>

            <v-card
              v-for="(response, index) in responses"
              :key="index"
              :class="$vuetify.breakpoint.smAndDown ? 'pa-1' : 'pa-5'"
              outlined
              class="my-8"
            >
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h5">
                    {{ response.signerRole === 'seller' ? 'Myyjän' : 'Tarjoajan' }} vastaus
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{
                      response.signed_date
                        ? formatDateTime(response.signed_date)
                        : response.responseDate
                    }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-card-text class="pt-2 pb-2">
                <preview-response
                  :response="response"
                  :responses="responses"
                  :referring="index > 0
                    ? formatDateTime(responses[index-1].signed_date) : offerSignedDate"
                  :show-signees="true"
                  :form="form"
                  :signatures="signatures"
                  :company-id="companyId"
                  :create-date="createDate"
                  :sellers="sellers"
                />
              </v-card-text>
            </v-card>
            <response-offer
              v-if="form.status !== '' &&
                form.status !== 'new' &&
                form.status !== 'fill' &&
                form.status !== 'cancelled' &&
                form.status !== 'closed' &&
                form.status !== 'agreed' &&
                (agent || currentSigner.name)"
              :referring="responses.length > 0
                ? formatDateTime(responses[responses.length-1].signed_date) : offerSignedDate"
              :form="form"
              :sellers="sellers"
              :signatures="signatures"
              :company-id="companyId"
              :create-date="createDate"
              :responses="responses"
            />
          </div>

          <div class="px-0 pt-2">
            <v-alert
              v-if="agent === false && authorizing === false && !form.offerers.length"
              :value="true"
              type="warning"
              text
              class="mb-4 mx-1"
            >
              Teidän tulee lisätä vähintään yksi tarjoaja kohdassa 2
              jotta tarjous voidaan allekirjoittaa ja lähettää.
            </v-alert>
            <v-alert
              v-if="form.status === 'closed' && agent === false"
              :value="true"
              type="info"
              text
              class="mb-4 mx-1"
            >
              Ostotarjous on hyväksytty!
            </v-alert>
            <v-alert
              v-if="form.status === 'cancelled'"
              :value="true"
              type="warning"
              text
              class="mb-4 mx-1"
            >
              Tarjousmenettely keskeytetty välittäjän toimesta
            </v-alert>
            <v-alert
              v-if="closeSnackbar"
              :value="true"
              text
              type="success"
              class="mb-4 mx-1"
            >
              Tarjous suljettu
            </v-alert>
            <v-alert
              v-if="snackbar && agent"
              :value="true"
              text
              type="success"
              class="mb-4 mx-1"
            >
              Muutokset tallennettu
            </v-alert>
            <v-alert
              v-if="linkSnackBar"
              text
              :value="true"
              type="success"
              class="mb-4 mx-1"
            >
              Tarjous lähetetty
            </v-alert>
            <v-alert
              v-if="cantEdit"
              text
              :value="true"
              type="warning"
              class="mb-4 mx-1"
            >
              Muokkaaminen estetty. Ainakin yksi tarjoajista on allekirjoittanut.
            </v-alert>
            <!--<accept-offer v-if="form.status === 'agreement' && agent !== true"/>-->
            <!-- UUSI ALLEKIRJOITUSNAPPILISTA -->
            <template v-if="thanksForSigning === false">
              <nets-signature
                v-if="agent === false &&
                  authorizing === false &&
                  (form.offerers.length && form.status === 'fill') &&
                  currentSigner"
                :form="form"
                :signers="form.offerers"
                :signatures="signatures"
                :company-id="companyId"
                :create-date="createDate"
              />
            </template>

            <v-alert
              v-if="thanksForSigning"
              text
              type="success"
            >
              Ostotarjous on allekirjoitettu ja toimitettu eteenpäin.
              HUOM! Mikäli allekirjoittajia on useampia, muista kirjautua ulos "Poistu"-napista
              ennen seuraavan allekirjoituksen aloittamista.
            </v-alert>

            <!-- TOUCH SIGNATURE STARTS. MOVE AWAY!
            <v-row>
              <v-col
                v-for="(offerer, index) in form.offerers"
                :key="`sig-${index}`"
                cols="12"
                md="6"
              >
                <touch-signature :field="offerer.touchSignature" :name="offerer.name"/>
              </v-col>
            </v-row>
            -->

            <v-card-actions>
              <v-layout :row="$vuetify.breakpoint.mdAndUp" :column="$vuetify.breakpoint.smAndDown">
                <v-spacer v-if="$vuetify.breakpoint.mdAndUp"/>
                <v-btn
                  v-if="(form.status === 'new' || form.status === 'fill') && agent"
                  :disabled="offerersHaveSigned || linkSnackBar || !sendable || cantEdit"
                  class="my-2 mx-1 px-3"
                  large
                  depressed
                  @click="editOffer()"
                >
                  Takaisin
                </v-btn>
                <v-btn
                  v-if="agent && (form.status === 'closed' || (fieldsExist))"
                  class="my-2 mx-1 px-3"
                  large
                  depressed
                  @click="printPdf(true)"
                >
                  Lataa PDF
                </v-btn>
                <v-btn
                  v-if="agent"
                  class="my-2 mx-1 px-3"
                  large
                  depressed
                  @click="copyOfferDialog = true"
                >
                  Kopioi
                </v-btn>
                <v-btn
                  v-if="
                    agent
                      && form.status !== 'closed'
                      && form.status !== 'fill'
                      && form.status !== 'new'
                      && form.status !== 'agreed'
                      && form.status !== 'cancelled'
                  "
                  class="my-2 mx-1 px-3"
                  large
                  depressed
                  @click="cancelOfferDialog = true"
                >
                  Keskeytä tarjous
                </v-btn>
                <v-btn
                  v-if="agent && form.status === 'agreed'"
                  class="my-2 mx-1 px-3"
                  large
                  depressed
                  @click="closeOfferDialogOpen()"
                >
                  Päätä tarjous
                </v-btn>
                <v-btn
                  v-if="agent
                    && fieldsExist
                    && (form.status === 'new'
                    || form.status === 'fill' || form.status === 'sellerresponse')"
                  :disabled="linkSnackBar || !sendable"
                  class="my-2 mx-1 px-3"
                  large
                  color="primary"
                  depressed
                  @click="sendToOfferer = true"
                >
                  Lähetä {{ form.offerers.length === 1 ? 'tarjoajalle' : 'tarjoajille' }}
                </v-btn>
                <v-btn
                  v-if="agent
                    && fieldsExist
                    && (form.status === 'filled' || form.status === 'offererresponse')"
                  :disabled="linkSnackBar || !sendable"
                  class="my-2 mx-1 px-3"
                  large
                  color="primary"
                  depressed
                  @click="sendToSeller = true"
                >
                  Lähetä myyjälle
                </v-btn>
                <v-btn
                  v-if="agent
                    && fieldsExist
                    && (form.status === 'declined' || form.status === 'agreed')"
                  class="my-2 mx-1 px-3"
                  large
                  color="primary"
                  depressed
                  @click="sendToBoth = true"
                >
                  Lähetä osapuolille
                </v-btn>
                <v-btn
                  v-if="(thanksForSigning || !currentSigner.name) && !agent"
                  class="my-2 mx-1 px-3"
                  color="primary"
                  large
                  depressed
                  @click="logout()"
                >
                  Poistu
                </v-btn>
              </v-layout>
            </v-card-actions>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <v-dialog
      v-model="sendToOfferer"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Lähetä {{ form.offerers.length === 1 ? 'tarjoajalle' : 'tarjoajille' }}
        </v-card-title>
        <v-card-text>
          <p class="mb-7">
            Lähetä tarjous allekirjoitettavaksi.
          </p>
          <div v-for="(offerer, index) in form.offerers" :key="index">
            <v-row
              class="mx-0"
              :class="{'mb-5' : responses.length ?
                responseSignatureExists(index) : signatureExists(offerer.ssn)}"
            >
              <v-checkbox
                v-model="offerer.send"
              />
              <v-text-field
                v-model="offerer.email"
                outlined
                :label="`Sähköposti ${offerer.name}`"
                :rules="textFieldRules"
                persistent-hint
                :hint="(responses.length
                  ? responseSignatureExists(index) : signatureExists(offerer.ssn)) ?
                  `HUOM! ${offerer.name} on jo allekirjoittanut` : null"
                required
              />
            </v-row>
          </div>
          <p class="mt-5 mb-0">
            Viestin mukana toimitetaan kertakäyttöinen salasana joka toimii
            kunnes tarjoaja allekirjoittaa tarjouksen.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="sendToOfferer=false;">
            Peruuta
          </v-btn>
          <v-btn
            :loading="sending"
            :disabled="!form.offerers.some(o => o.send)"
            text
            color="primary"
            @click="sendNow()"
          >
            Lähetä
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="sendToSeller"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Lähetä myyjälle
        </v-card-title>
        <v-card-text>
          <p class="mb-7">
            Lähetä vastaus kohteen myyjälle allekirjoitettavaksi.
            (Huom. Voit muokata myyjän sähköpostiosoitetta vain asiakasrekisterin kautta.)
          </p>
          <div v-for="(seller, i) in sellers" :key="i">
            <v-row class="mx-0" :class="{'mb-5' : responseSignatureExists(i)}">
              <v-checkbox
                v-model="seller.send"
              />
              <v-text-field
                v-model="seller.email"
                outlined
                disabled
                :label="`Sähköposti ${seller.name}`"
                persistent-hint
                :hint="responseSignatureExists(i) ?
                  `HUOM! ${seller.name} on jo allekirjoittanut` : null"
                required
              />
            </v-row>
          </div>
          <p class="mt-5 mb-0">
            Viestin mukana toimitetaan kertakäyttöinen salasana joka toimii
            kunnes myyjä vastaa tarjoukseen.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="sendToSeller=false;">
            Peruuta
          </v-btn>
          <v-btn
            :disabled="!sellers.some(s => s.send)"
            :loading="sending"
            color="primary"
            text
            @click="sendToSellerAction()"
          >
            Lähetä
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="sendToBoth"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Lähetä osapuolille
        </v-card-title>
        <v-card-text>
          <p class="mb-6">
            Lähetä tarjous tarkasteltavaksi molemmille osapuolille. Tämä kuittaa tarjouksen
            käsitellyksi ja poistaa tarjouksen ilmoituksistasi. Linkin mukana tuleva koodi
            vanhenee 7 vuorokauden päästä lähettämisestä.
          </p>
          <p class="title mb-3">
            Tarjoajat
          </p>
          <v-text-field
            v-for="(offerer, index) in form.offerers"
            :key="`o-${index}`"
            v-model="offerer.email"
            :label="offerer.name"
            :rules="textFieldRules"
            disabled
            outlined
            required
          />
          <p class="title mb-3">
            Myyjät
          </p>
          <v-text-field
            v-for="(s, i) in sellers"
            :key="`s-${i}`"
            v-model="s.email"
            :label="s.name"
            outlined
            :rules="textFieldRules"
            disabled
            required
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="sendToBoth=false;">
            Peruuta
          </v-btn>
          <v-btn
            :loading="sending"
            color="primary"
            text
            @click="sendToBothAction()"
          >
            Lähetä
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="saveDialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Tallenna
        </v-card-title>
        <v-card-text>
          <template v-if="agent" class="mt-3 mb-1 ml-0">
            Huom! Teithän kaikki tarvittavat muutokset tarjoukseen.
          </template>
          <template v-else class="mt-3 mb-1 ml-0">
            Huom! Teithän kaikki tarvittavat muutokset tarjoukseen.
            Tallentaminen kirjaa sinut ulos ja kertakäyttöinen salasanasi lakkaa toimimasta.
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
            @click="saveDialog = false"
          >
            Peruuta
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="saveOffer()"
          >
            Tallenna
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="acceptSignature"
      width="600"
    >
      <nets-accept-signature
        :offerers="form.offerers"
        :sellers="sellers"
        :responses="responses"
        :first-signature="form.status === 'fill'"
      />
    </v-dialog>
    <v-dialog v-model="closeOfferDialog" width="500">
      <v-card>
        <v-card-title class="text-h5">
          Päätä tarjous
        </v-card-title>
        <v-card-text>
          <p>
            Anna lopullinen velaton kauppahinta ja siirry kauppakirjan luontiin.
          </p>
          <v-text-field
            v-model="finalOffer"
            label="Velaton kauppahinta"
            outlined
            class="mt-4"
            hide-details
            append-icon="euro_symbol"
            type="number"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="closeOfferDialog = false">
            Peruuta
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="closeOffer()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancelOfferDialog" width="500">
      <v-card>
        <v-card-title class="text-h5">
          Keskeytä tarjous
        </v-card-title>
        <v-card-text>
          <p>
            Oletko varma että haluat keskeyttää sähköisen tarjousmenettelyn?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="cancelOfferDialog = false">
            Peruuta
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="cancelOffer()"
          >
            Kyllä
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <copy-offer-dialog :copy-offer-dialog="copyOfferDialog"/>
    <v-dialog v-model="cancelled" max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          Tunnistautuminen peruutettu
        </v-card-title>
        <v-card-text>
          <p>Voit tunnistautua uudelleen.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
            color="primary"
            @click="cancelled = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import { mask } from 'vue-the-mask';
import pdf from 'vue-pdf';
import { apiGet, apiPost, apiPut } from '../api';

const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('../assets/fonts.js');
// const pdfFonts = require('assets/pdfFonts.js');

export default {
  name: 'Offer',
  components: {
    pdf,
    gdpr: () => import('@/components/Gdpr'),
    'preview-offer': () => import('@/components/PreviewOffer'),
    'response-offer': () => import('@/components/AgentResponseOffer'),
    'preview-response': () => import('@/components/PreviewResponse'),
    'nets-signature': () => import('@/components/NetsSignature'),
    'nets-accept-signature': () => import('@/components/NetsAcceptSignature'),
    'offerer-form': () => import('@/components/OffererForm'),
    'copy-offer-dialog': () => import('@/components/offer/CopyOfferDialog'),
    // 'touch-signature': () => import('@/components/TouchSignature'),
  },
  directives: {
    mask,
  },
  beforeRouteLeave(to, from, next) {
    if (this.userHasEdited) {
      // eslint-disable-next-line no-alert
      const answer = window
        .confirm('Tallentamattomat muutokset häviävät. Oletko varma että haluat poistua?');
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data: () => ({
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Virheellinen sähköpostiosoite.';
      },
    },
    attachments: ['Myyntiesite', 'Kiinteistö kartalla', 'Pohjapiirros', 'Kuntotarkastus', 'Energiatodistus', 'Kosteusmittaus', 'Kiinteistörekisteriote', 'Rasitustodistus', 'Lainhuuto', 'Vuokraoikeustodistus'],
    osakeAttachments: ['Myyntiesite', 'Kunnossapitotarveselvitys', 'Pohjapiirros', 'Kuntotarkastus', 'Energiatodistus', 'Kosteusmittaus', 'Isännöitsijätodistus', 'Yhtiöjärjestys', 'Tase ja tuloslaskelma', 'Toimintakertomus'],
    signingAgent: ' ',
    finalOffer: 0,
    numPages: 0,
    cancelled: false,
    cancelOfferDialog: false,
    closeOfferDialog: false,
    copyOfferDialog: false,
    acceptGdpr: false,
    showGdpr: false,
    cantEdit: false,
    userHasEdited: false,
    sending: false,
    signatures: [],
    acceptSignature: false,
    companyId: null,
    expired: false,
    sendable: false,
    role: 'seller',
    loadingThings: true,
    pdfLoading: true,
    authorizing: true,
    edit: true,
    editing: {
      offerer: false,
    },
    indexes: {
      offerer: null,
    },
    duplicates: {
      offererEmail: false,
    },
    personForm: {
      valid: false,
    },
    fieldsExist: false,
    dialog: false,
    signDialog: false,
    saveDialog: false,
    thankyou: false,
    log: [],
    snackbar: false,
    linkSnackBar: false,
    closeSnackbar: false,
    sendToOfferer: false,
    sendToSeller: false,
    sendToBoth: false,
    sellers: [],
    createDate: null,
    thanksForSigning: false,
    pdfDataUrl: null,
    statusObject: {
      new: 'Luonnos tallennettu',
      fill: 'Luonnos lähetetty tarjoajalle',
      filled: 'Tarjoaja on allekirjoittanut ostotarjouksen',
      agreement: 'Tarjous lähetetty myyjälle',
      decision: 'Myyjä on vastannut tarjoukseen',
    },
    textFieldRules: [
      v => !!v || 'Pakollinen kenttä',
    ],
    timeRule: [
      v => v.length >= 5 || 'Syötä muodossa HH:MM',
      v => (parseInt(v.substring(0, 2), 10) < 24) || 'Virheellinen aika',
      v => (parseInt(v.substring(3, 5), 10) < 60) || 'Virheellinen aika',
    ],
    newPerson: {
      isCompany: false,
      companyName: '',
      companyNumber: '',
      name: '',
      phone: '',
      address: '',
      email: '',
      ssn: '',
      nationality: 'Suomi',
      signature: false,
      assetTransfer: false,
      pep: false,
      pepDescription: '',
      touchSignature: {
        image: null,
        imageId: null,
      },
    },
    offererEmail: '',
    offererName: '',
    showPreview: false,
    panel: 0,
    responsePanel: 0,
    thankYouRole: 'offerer',
    datePickerMenu: false,
    datePickerMenu2: false,
    datePickerMenu3: false,
    datePickerMenu4: false,
    datePickerMenu5: false,
    datePickerMenu6: false,
    datePickerMenu7: false,
    offerSignedDate: ' ',
    deposit1: 'Mikäli tarjouksen tekijä kieltäytyy tekemästä kauppaa myyjän hyväksyttyä tarjouksen, tarjouksen tekijä sitoutuu maksamaan myyjälle edellä mainitun vakiokorvauksen. Mikäli myyjä kieltäytyy tekemästä hyväksymänsä tarjouksen mukaista kauppaa, myyjä sitoutuu maksamaan tarjouksen tekijälle edellä mainitun vakiokorvauksen.', // eslint-disable-line
    deposit11: 'Vakiokorvaus on enintään 4% tarjotusta kauppahinnasta. Rajoitus ei koske sopimuksia, joissa tarjoaja on joku muu, kuin kuluttaja.',
    deposit12: 'Vakiokorvaus on enintään 10% tarjotusta kauppahinnasta. Vakiokorvaus (sopimussakko) on vahingonkorvauksen yläraja eikä osapuolilla ole oikeutta suurempaan korvaukseen todellisesta vahingosta vaikka se olisi vakiokorvausta suurempi.',
    deposit122: 'Vakiokorvaus (sopimussakko) on vahingonkorvauksen yläraja eikä osapuolilla ole oikeutta suurempaan korvaukseen todellisesta vahingosta vaikka se olisi vakiokorvausta suurempi.',
    deposit13: 'Korvausvelvollisuus edellyttää maakaaren 2 luvun 1§:n mukaista tarjousmenettelyä (kaupanvahvistajan vahvistuksin tai sähköisesti maakaaren 5 luvun 3§:ssä tarkoitetussa järjestelmässä).',
    deposit2: 'Tarjouksen tekijällä on käsirahan maksuvelvollisuus, vaikka käsirahaa ei maksettaisi tarjouksen tekemisen yhteydessä. Jos käsirahaa ei ole maksettu ja tarjouksen tekijä kieltäytyy tekemästä kauppoja saatuaan ilmoituksen tarjouksen hyväksynnästä on tarjouksen tekijällä sovitun käsirahan suuruisen vakiokorvauksen maksuvelvollisuus. Mikäli myyjä ei hyväksy tarjousta, tai mikäli tarjouksen ehdot eivät toteudu, käsiraha palautetaan heti korottomana tarjouksen tekijälle. Mikäli tarjouksen tekijä kieltäytyy tekemästä kauppaa myyjän hyväksyttyä tarjouksen, jää käsiraha myyjälle korvauksena sopimuksen perumisesta. Mikäli myyjä kieltäytyy tekemästä hyväksymänsä tarjouksen mukaista kauppaa, hänen on palautettava käsiraha ja maksettava tarjouksen tekijälle käsirahan suuruinen korvaus. Käsiraha sisältyy kauppahinnan ensimmäiseen erään.', // eslint-disable-line
    deposit21: 'Käsirahan suuruus on enintään 4% tarjotusta kauppahinnasta. Rajoitus ei koske sopimuksia, joissa tarjoaja on joku muu, kuin kuluttaja.',
    deposit22: 'Käsirahan suuruus on enintään 10% tarjotusta kauppahinnasta.',
    deposit23: 'Tarjous on osapuolia lopullisesti sitova kun kaupan päättämisestä sovitaan maakaaren 2 luvun 1§:n edellyttämällä tavalla (kaupanvahvistajan vahvistuksin tai sähköisesti maakaaren 5 luvun 3§:ssä tarkoitetussa järjestelmässä).',
    deposit3: 'Jos kaupasta ei ole sovittu maakaaren 2 luvun 1§:n edellyttämässä muodossa (kaupanvahvistajan vahvistuksin tai sähköisesti maakaaren 5 luvun 3§:ssä tarkoitetussa järjestelmässä) on kaupan tekemisestä kieltäytyneen osapuolen kuitenkin korvattava toiselle osapuolelle kaupantekoon liittyvistä tarpeellisista toimista aiheutuneet, maakaaren 2 luvun 8§:n mukaiset kohtuulliset kustannukset. Korvattavia kustannuksia ovat myös välitysliikkeelle kaupan valmistelusta aiheutuneet kohtuulliset kustannukset sekä korvaus tehdystä työstä.', // eslint-disable-line
    property: {},
    taxPayments: [
      { value: 2, text: 'Ei valittu' },
      { value: 0, text: 'Ei varainsiirtoverovelvollinen' },
      { value: 1, text: 'Ostaja suorittaa varainsiirtoveron kaupantekotilaisuudessa' },
    ],
    form: {
      selectedAttachments: '',
      offerers: [],
      offer: 0,
      offerValidUntilDate: new Date().toISOString().substr(0, 10),
      offerValidUntilTime: '12:00',
      signingDate: new Date().toISOString().substr(0, 10),
      debtPortion: 0,
      debtPortions: [
        {
          text: 'Ei velkaosuutta',
          value: 0,
        }, {
          text: 'Huoneistolla on velkaosuutta',
          value: 1,
        },
      ],
      debtPortionPayer: 0,
      debtPortionPayers: [
        { value: 0, text: 'Ei valittu' },
        { value: 1, text: 'Velkaosuus maksetaan pois kaupantekotilaisuudessa' },
        { value: 2, text: 'Ostaja ottaa velkaosuuden vastattavakseen' },
      ],
      paymentMethod: 'Käteinen (tilisiirto) kaupanteossa',
      paymentMethods: [
        'Ei valittu',
        'Käteinen (tilisiirto) kaupanteossa',
        'Osamaksu',
        'Muu (anna selite)',
      ],
      ownershipTransfer: 0,
      ownershipTransfers: [
        { value: 2, text: 'Ei valittu' },
        { value: 0, text: 'Kaupanteossa' },
        { value: 1, text: 'Muu (anna selite)' },
      ],
      ownershipTransferDetail: ' ',
      possessionTransfer: 2,
      possessionTransfers: [
        { value: 2, text: 'Ei valittu' },
        { value: 0, text: 'Kaupanteossa' },
        { value: 1, text: 'Muu (anna selite)' },
      ],
      possessionDetail: ' ',
      debt: 0,
      debtDate: '',
      expense: 0,
      expenses: [
        { value: 2, text: 'Ei valittu' },
        { value: 0, text: 'Hallintaoikeuden siirtymisestä lähtien' },
        { value: 1, text: 'Muu (anna selite)' },
      ],
      expenseDetail: '',
      risk: 0,
      risks: [
        { value: 2, text: 'Ei valittu' },
        { value: 0, text: 'Omistusoikeuden siirtymisestä lähtien' },
        { value: 1, text: 'Muu (anna selite)' },
      ],
      riskDetail: '',
      conditions: {
        loan: false,
        sell: false,
        permit: false,
        humidity: false,
        conditiononly: false,
        condition: false,
        expense: false,
        other: false,
        marketing: false,
      },
      expenseDate: new Date().toISOString().substr(0, 10),
      paymentDetail: '',
      paymentDelay: 500,
      paymentOther: '',
      paymentDate: new Date().toISOString().substr(0, 10),
      deposit: 'Vakiokorvaus',
      depositValues: [
        'Vakiokorvaus',
        'Käsiraha',
      ],
      depositInEuros: 0,
      otherConditions: '',
      identification1: {},
      identification2: {},
      identification3: {},
      identification4: {},
      identification5: {},
      identification6: {},
      status: undefined,
      responseOffer: {},
      signers: [],
    },
    currentIndexSignatures: [],
    passCode: '',
    pdfContent: [],
    timeMask: '##:##',
    aboutConditions: 'Mikäli jokin ostotarjouksen kohta on ristiriidassa tähän kohtaan "5.3 muut ehdot" kirjatun ehdon kanssa, ovat tähän kohtaan kirjatut ehdot etusijalla.',
    ifOccurs: 'Mikäli kosteusmittauksessa / kuntotarkastuksessa ilmenee asunnon ikä, kunto ja vastaavat seikat huomioon ottaen sellaisia merkittäviä vikoja tai puutteita, joista ostaja ei ole aiemmin ollut tietoinen, on ostajalla oikeus vetäytyä kaupasta. Kosteusmittauksen / kuntotarkastuksen kustannuksista vastaavat myyjä ja ostaja puoliksi',
  }),
  computed: {
    ...mapGetters({
      isAuthorized: 'isAuthorized',
      agent: 'agent',
      responseOffer: 'responseOffer',
      responses: 'responses',
    }),
    ...mapState({
      currentSigner: state => state.currentSigner,
    }),
    oldVersion() {
      return moment(this.createDate, 'YYYY-MM-DD H:m:s') < moment('2020-11-10 00:00:00', 'YYYY-MM-DD H:m:s');
    },
    governmentRight() {
      return moment(this.createDate, 'YYYY-MM-DD H:m:s') > moment('2021-05-10 00:00:00', 'YYYY-MM-DD H:m:s') && this.propertyType === 0;
    },
    footerText() {
      let titleText = 'Huoneiston ostotarjous:';
      if (this.propertyType === 0) {
        titleText = 'Kiinteistön ostotarjous / esisopimus:';
      } else if (this.propertyType === 2) {
        titleText = 'Ostotarjous / vuokraoikeus rakennuksineen:';
      }
      return `${titleText} ${this.property.kohdenimi} ${this.property.huoneistonro}`;
    },
    debtPartText() {
      return 'Mikäli mahdollisen velkaosuuden määrää ei makseta pois kaupantekotilaisuudessa, ottaa ostaja huoneistokohtaisen velkaosuuden vastattavakseen. Mikäli velkaosuuden määrä on muuttunut edellä mainitusta, muuttuu maksettavan kauppasumman määrä niin, että hyväksytty velaton kauppahinta pysyy samana. Mahdollisen velkaosuuden määrä pyritään tarkistamaan kaupantekopäivälle. Huoneistokohtainen lainaosuuden määrä on saattanut muuttua pienemmäksi tai suuremmaksi isännöitsijäntodistuksessa mainitusta maksettujen tai mahdollisesti maksamattomien rahoitusvastikkeiden johdosta tai se on voitu maksaa kokonaisuudessaan pois. Viivästyskorko on korkolain mukainen.';
    },
    debtDateAddText() {
      if (this.property.velkaosuuspvm) {
        return `\nVelkaosuuden päivämäärä: ${moment(this.property.velkaosuuspvm, 'YYYY-MM-DD').format('DD.MM.YYYY')}`;
      }
      return '';
    },
    expenseText() {
      if (this.isShare) {
        return ' Yhtiölle suoritettavista maksuista ja muista huoneistoon kohdistuvista maksuista vastaa ostaja:';
      }
      if (this.propertyType === 0) {
        return ' Kiinteistön ylläpitokustannuksista vastaa ostaja:';
      }
      return 'Kohteen ylläpitokustannuksista vastaa ostaja:';
    },
    propertyType() {
      if (+this.property.osakevaikiinteisto === 0 && +this.property.tontinomistus > 0) {
        return 2; // vuokraoikeus
      }

      if (+this.property.osakevaikiinteisto === 1) return 1; // osake

      return 0; // kiinteistö
    },
    size() {
      const plots = [4, 13, 14, 15, 18];
      if (plots.includes(+this.property.kohdetyyppi)) {
        return this.property.pintaala;
      }
      return this.property.omktontinpinta;
    },
    createdAfterLawChange() {
      if (!this.createDate) return true;

      return moment(this.createDate, 'YYYY-MM-DD H:m:s') > moment('2024-11-01 00:00:00', 'YYYY-MM-DD H:m:s');
    },
    deposit1text() {
      if (this.isShare) {
        return `${this.deposit1} ${this.deposit11}`;
      }
      if (this.propertyType === 0) {
        // Law change 1.11.2024 remove condition texts
        if (this.createdAfterLawChange) {
          return `${this.deposit1} ${this.deposit122}`;
        }

        return `${this.deposit1} ${this.deposit12} ${this.deposit13}`;
      }
      return `${this.deposit1} ${this.deposit12}`;
    },
    deposit2text() {
      if (this.isShare) {
        return `${this.deposit2} ${this.deposit21}`;
      }
      if (this.propertyType === 0) {
        // Law change 1.11.2024 remove condition texts
        if (this.createdAfterLawChange) {
          return this.deposit2;
        }

        return `${this.deposit2} ${this.deposit22} ${this.deposit23}`;
      }
      return `${this.deposit2} ${this.deposit22}`;
    },
    depositTexts() {
      return {
        deposit1: this.deposit1text,
        deposit2: this.deposit2text,
        deposit3: this.deposit3,
      };
    },
    pdfTitle() {
      if (this.isShare) {
        return 'HUONEISTON OSTOTARJOUS\n';
      }
      if (this.propertyType === 0) {
        return 'KIINTEISTÖN OSTOTARJOUS / ESISOPIMUS\n';
      }
      return 'OSTOTARJOUS / VUOKRAOIKEUS RAKENNUKSINEEN\n';
    },
    pdfSubtitle() {
      if (this.isShare) {
        return 'Tarjoudun ostamaan huoneiston hallintaan oikeuttavat osakkeet/osuudet jäljempänä mainituin ehdoin';
      }
      if (this.propertyType === 0) {
        return 'Tarjoudun ostamaan kiinteistön jäljempänä mainituin ehdoin';
      }
      return 'Tarjoudun ostamaan vuokraoikeuden rakennuksineen jäljempänä mainituin ehdoin';
    },
    isShare() {
      return +this.propertyType === 1;
    },
    cannotEdit() {
      if (this.agent && this.form.status === 'new') return false;
      return true;
    },
    allOfferersHaveSigned() {
      if (this.form.status === 'agreement') {
        if (this.sellers.find(seller => seller.signature !== true)) {
          return false;
        }
        return true;
      }
      if (this.form.offerers.find(offerer => offerer.signature === false)) {
        return false;
      }
      return true;
    },
    codeValid() {
      return this.passCode.length > 0;
    },
    signaturesExist() {
      return this.signatures.length > 0;
    },
    offerersHaveSigned() {
      if (this.signatures.length > 0) {
        return this.signatures.length === this.form.offerers.length;
      }
      return false;
    },
    filteredOwnershipTransfers() {
      return this.form.ownershipTransfers
        .filter(n => !(n === 'Osakkeiden omistusoikeus siirtyy kaupantekotilaisuudessa kokonaiskauppasumman maksua vastaan' && this.form.paymentMethod === 'Osamaksu') // eslint-disable-line
        && !(n === 'Osakkeiden omistus siirtyy loppukauppahinnan maksua vastaan' && this.form.paymentMethod === 'Käteinen (tilisiirto) kaupanteossa')); // eslint-disable-line
    },
    paymentDateFormatted() {
      return moment(this.form.paymentDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
    debtDateFormatted() {
      if (!this.form.debtDate) return '';
      return moment(this.form.debtDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
    debtDateText() {
      if (!this.form.debtDate) return `Isännöitsijäntodistuksen mukaisesti huoneistokohtainen velkaosuus on\n ${this.form.debt.replace('.', ',')} euroa${this.debtDateAddText}`;
      return `Isännöitsijäntodistuksen päivämäärä ${this.debtDateFormatted} , jonka\n mukaisesti huoneistokohtainen velkaosuus on ${this.form.debt.replace('.', ',')} euroa${this.debtDateAddText}`;
    },
    sellingPrice() {
      return (parseFloat(this.form.offer) - parseFloat(this.form.debt.replace(',', '.'))).toFixed(2);
    },
    expenseDateFormatted() {
      return moment(this.form.expenseDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
    offerValidUntilDateFormatted() {
      return moment(this.form.offerValidUntilDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
    signingDateFormatted() {
      return moment(this.form.signingDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
  },

  watch: {
    form: {
      handler() {
        this.userHasEdited = true;
      },
      deep: true,
      immediate: false,
    },
  },

  async created() {
    this.$bus.$on('SIGN_AND_LOGOUT', async () => {
      if (this.agent === false) {
        this.thankYouRole = (this.status === 'agreement' || this.status === 'sellerresponse')
          ? 'seller' : 'offerer';
        this.thankyou = true;
        await this.getOffer();
        await this.printPdf(true);
        await this.logout();
      } else {
        await this.getOfferLog();
        await this.getOffer();
      }
    });
    this.$bus.$on('CLOSE_COPY_OFFER_DIALOG', () => {
      this.copyOfferDialog = false;
      this.snackbar = false;
      this.linkSnackBar = false;
      this.cantEdit = false;
    });
    this.$bus.$on('RELOAD_OFFER', async () => {
      await this.getOfferLog();
      await this.getSignatures();
      await this.getOffer();
      this.edit = true;
      this.$bus.$emit('HIDE_GLOBAL_LOADER');
    });
    this.$bus.$on('closeOffererDialog', async () => {
      this.closeOffererDialog();
    });
    this.$bus.$on('companyOrPersonChange', async () => {
      this.companyOrPersonChange();
    });
    this.$bus.$on('loadSignatures', async () => {
      await this.getSignatures();
      await this.getOffer();
    });
    this.$bus.$on('loadSignaturesPromise', async (resolve) => {
      await this.getSignatures();
      await this.getOffer();
      resolve();
    });
    this.$bus.$on('responseSendable', async () => {
      this.sendable = true;
    });
    this.$bus.$on('responseNotSendable', async () => {
      this.sendable = false;
    });
    this.$bus.$on('showThanksForSigning', async () => {
      this.thanksForSigning = true;
    });
    // this.$bus.$on('updateOffer', async () => {
    //   await this.getOffer();
    // });
    this.$bus.$on('pdf', async () => {
      this.printPdf(true);
    });
    this.$bus.$on('close_dialog', async () => {
      const query = { ...this.$route.query };
      delete query.signature;
      this.$router.push({ query });
      this.acceptSignature = false;
    });
  },
  async mounted() {
    // Poll if offer is different than current offer in session. Expire session if so.
    setInterval(async () => {
      if (this.isAuthorized) {
        await this.pollOffer();
      }
    }, 30000);

    if (this.agent) {
      await this.setCurrentProperty(this.$route.params.id);
    }

    const authorization = await apiGet(`authorization/property/${this.$route.params.id}/${this.$route.params.offerId}`); // eslint-disable-line
    if (authorization.success) {
      this.setAuthorization(JSON.parse(authorization.result.isAuthorized));
      if (JSON.parse(authorization.result.isAuthorized)) {
        if (authorization.result.signerEmail) {
          this.setCurrentSigner({
            name: authorization.result.signerName,
            email: authorization.result.signerEmail,
            participantIndex: authorization.result.participantIndex,
          });
        }
        await this.getProperty();
        await this.getSignatures();
        await this.getOffer();
        await this.getOfferLog();
        await this.setAgent(JSON.parse(authorization.result.agent));
      }
    } else {
      this.setAuthorization(false);
      this.setCurrentSigner({});
    }
    this.authorizing = false;
    await this.getSignatures();
    if (this.$route.query && this.$route.query.signature && this.isAuthorized) {
      this.acceptSignature = true;
    } else if (this.offerersHaveSigned === false) {
      // this.edit = true;
    }
    this.loadingThings = false;
    this.userHasEdited = false;
    if (this.propertyType === 1) {
      this.attachments = this.osakeAttachments;
    }

    if (this.$route.query.cancel) {
      const query = { ...this.$route.query };
      delete query.cancel;
      this.$router.push({ query });
      this.cancelled = true;
    }
  },
  methods: {
    ...mapActions({
      setAuthorization: 'setAuthorization',
      setAgent: 'setAgent',
      setCurrentSigner: 'setCurrentSigner',
      setCurrentProperty: 'setCurrentProperty',
      setCompanyName: 'setCompanyName',
      setResponseOffer: 'setResponseOffer',
      setSigners: 'setSigners',
      setSignerRole: 'setSignerRole',
      getOfferResponses: 'getOfferResponses',
    }),
    async getCurrentIndexSignatures() {
      const responseidx = this.responses.length + 1;
      const response = await apiGet(`nets/signatures/${this.$route.params.id}/${this.$route.params.offerId}/${responseidx}`);
      if (response.result.length) {
        this.currentIndexSignatures = response.result;
      }
    },
    signatureExists(ssn) {
      if (ssn === '') return false;
      return this.signatures.some(s => s.ssn === ssn);
    },
    responseSignatureExists(index) {
      return this.currentIndexSignatures.some(s => s.offerer_index === index.toString());
    },
    selectAttachment(item) {
      if (this.form.selectedAttachments !== '') {
        this.form.selectedAttachments = `${this.form.selectedAttachments}, ${item}`;
      } else {
        this.form.selectedAttachments = item;
      }
      this.attachments = this.attachments.filter(i => i !== item);
    },
    async getSignatures() {
      const responseidx = 0;
      const response = await apiGet(`nets/signatures/${this.$route.params.id}/${this.$route.params.offerId}/${responseidx}`);
      this.signatures = response.result;
      if (this.offerersHaveSigned && this.form.status === 'fill') {
        await this.offerFilled();
      }
    },
    closeOfferDialogOpen() {
      this.finalOffer = this.form.offer;
      this.closeOfferDialog = true;
    },
    async cancelOffer() {
      const response = await apiGet(`properties/cancel/${this.$route.params.offerId}`);
      window.location = response.redirectUrl;
    },
    async closeOffer() {
      const response = await apiPost(`properties/close/${this.$route.params.offerId}`, {
        offerers: this.form.offerers,
        finalOffer: this.finalOffer,
      });
      this.closeOfferDialog = false;
      window.location = response.redirectUrl;
    },
    isSigned(ssn) {
      return this.signatures.some(s => s.ssn === ssn);
    },
    removeOfferer(index) {
      this.form.offerers.splice(index, 1);
    },
    formatDateTime(datetime) {
      return moment(datetime).format('DD.MM.YYYY H:mm');
    },
    closeOffererDialog() {
      this.dialog = false;
      this.newPerson.isCompany = false;
      this.editing.offerer = false;
      this.indexes.offerer = null;
    },
    editOfferer(index) {
      this.newPerson = _.cloneDeep(this.form.offerers[index]);
      this.indexes.offerer = index;
      this.dialog = true;
      this.editing.offerer = true;
    },
    async editOffer() {
      console.warn('hae signaturet!!!');
      await this.getSignatures();
      if (!this.signatures.length) {
        this.edit = true;
      } else {
        this.cantEdit = true;
      }
    },
    checkBox(checked = ' ', title, span = 1, bottomBorder = true, noBorders = false, small = false, rowSpan = 1) { // eslint-disable-line
      const checkbox = {
        table: {
          widths: [small ? 4 : 8, '*'],
          body: [
            [
              {
                text: checked,
                fontSize: small ? 5 : 8,
                margin: [2, 0.5, 0, 0],
                border: [noBorders, noBorders, true, true],
              }, {
                text: title,
                fontSize: small ? 6 : 9,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                color: '#666666',
              },
            ],
          ],
        },
        margin: [-4, -2, 0, 5],
        colSpan: span,
        rowSpan,
        border: [!noBorders, !noBorders, !noBorders, bottomBorder],
        layout: {
          hLineColor: () => '#888888',
          vLineColor: () => '#888888',
          hLineWidth: () => 0.2,
          vLineWidth: () => 0.2,
        },
      };

      return checkbox;
    },
    async next() {
      if (this.agent !== true) {
        await this.saveOffer(true);
      }
      await this.saveOffer(true);
      await this.printPdf();
    },
    async printPdf(load = false) {
      if (load === false) {
        this.pdfLoading = true;
      }
      const line = '#888888';
      const textColor = '#333333';

      const greyBorders = () => ({
        hLineColor: () => line,
        vLineColor: () => line,
        hLineWidth: () => 0.2,
        vLineWidth: () => 0.2,
      });

      const icons = {
        share: '',
        crop: '',
        home: '',
      };

      try {
        this.edit = false;
        this.pdfContent = [];
        const heading = {
          table: {
            widths: [17, '*'],
            body: [
              [
                {
                  text: this.isShare ? icons.share : icons.home, // eslint-disable-line
                  font: 'Icons',
                  color: '#333333',
                  fontSize: 21,
                  margin: [0, 0, 0, 0],
                },
                {
                  text: [
                    { text: this.pdfTitle, fontSize: 12, color: '#333333' },
                    {
                      text: this.pdfSubtitle,
                      fontSize: 8,
                      margin: [0, -2, 0, 0],
                      color: '#333333',
                    },
                  ],
                },
              ],
            ],
          },
          margin: [0, -10, 0, 0],
          layout: 'noBorders',
        };
        this.pdfContent.push(heading);
        this.pdfContent.push({
          text: '1. KOHDE',
          margin: [0, 3, 0, -2],
          fontSize: 8.5,
          color: textColor,
        });
        let estateIdTitle = '1.1 Kiinteistötunnus';
        let areaTitle = '1.2 Kiinteistörekisteriotteen mukainen pinta-ala (m²)';
        if (this.propertyType === 2) {
          estateIdTitle = '1.1 Kiinteistötunnus/laitostunnus';
          areaTitle = '1.2 Vuokra-alueen pinta-ala noin (m²)';
        }
        this.pdfContent.push({
          table: {
            widths: ['*', '*'],
            body: [
              [
                this.isShare
                  ? this.pdfTable('1.1 Yhtiön nimi', this.property.yhtionimi || ' ', 1)
                  : this.pdfTable(estateIdTitle, this.property.omkkiinteistotunnus || ' ', 1),
                this.isShare
                  ? this.pdfTable('1.2 Osakkeiden / osuuksien numerot', `${this.property.osakealku} - ${this.property.osakeloppu}`, 1)
                  : this.pdfTable(areaTitle, this.size.replace('.', ','), 1), // eslint-disable-line
              ],
              [
                this.pdfTable(this.isShare ? '1.3 Huoneiston osoite ja numero' : '1.3 Osoite', `${this.property.kohdenimi} ${this.property.huoneistonro}, ${this.property.postinumero} ${this.property.kaupunki}`, 2), // eslint-disable-line
                '',
              ],
            ],
          },
          margin: [0, 5, 0, 5],
          layout: greyBorders(),
        });
        this.pdfContent.push({
          text: '2. TARJOUKSEN TEKIJÄT',
          margin: [0, 3, 0, -2],
          fontSize: 8.5,
          color: textColor,
        });

        const offerer1 = {
          table: {
            widths: ['*', '*', '*', '*'],
            body: [],
          },
          margin: [0, 0, 0, 0],
          layout: 'noBorders',
        };

        const offerer2 = {
          table: {
            widths: ['*', '*', '*', '*'],
            body: [],
          },
          margin: [0, 0, 0, 0],
          layout: 'noBorders',
        };

        let offererDetails2 = {};
        let offererDetails1 = {};
        if (this.form.offerers[0]) {
          [offererDetails1] = this.form.offerers;
        }
        if (this.form.offerers[1]) {
          [, offererDetails2] = this.form.offerers;
        }

        if (offererDetails1.isCompany) {
          let companyName = `${offererDetails1.companyName} (${offererDetails1.name})`;
          if (offererDetails1.ssn) {
            companyName = `${offererDetails1.companyName} (${offererDetails1.name} ${offererDetails1.ssn})`;
          }
          offerer1.table.body.push(
            [
              this.pdfTable('Nimi', companyName || ' ', 2),
              '',
              this.pdfTable('Hetu / Y-tunnus', this.agent ? (offererDetails1.companyNumber || ' ') : ' ', 1),
              this.pdfTable('Kansalaisuus', offererDetails1.nationality || ' ', 1),
            ],
          );
        } else {
          offerer1.table.body.push(
            [
              this.pdfTable('Nimi', offererDetails1.name || ' ', 2),
              '',
              this.pdfTable('Hetu / Y-tunnus', this.agent ? (offererDetails1.ssn || ' ') : ' ', 1),
              this.pdfTable('Kansalaisuus', offererDetails1.nationality || ' ', 1),
            ],
          );
        }
        offerer1.table.body.push(
          [
            this.pdfTable('Osoite', `${offererDetails1.address || ''}${offererDetails1.zip ? ',' : ''} ${offererDetails1.zip || ''} ${offererDetails1.city || ''}`, 2),
            '',
            this.pdfTable('Sähköposti', offererDetails1.email || ' ', 1),
            this.pdfTable('Puhelin', offererDetails1.phone || ' ', 1),
          ],
        );

        if (!this.oldVersion) {
          offerer1.table.body.push(
            [
              this.pepTable(offererDetails1.pep, offererDetails1.pepDescription),
              '',
              '',
              '',
            ],
          );
        }

        if (offererDetails2.isCompany) {
          let companyName = `${offererDetails2.companyName} (${offererDetails2.name})`;
          if (offererDetails2.ssn) {
            companyName = `${offererDetails2.companyName} (${offererDetails2.name} ${offererDetails2.ssn})`;
          }
          offerer2.table.body.push(
            [
              this.pdfTable('Nimi', companyName || ' ', 2),
              '',
              this.pdfTable('Hetu / Y-tunnus', this.agent ? (offererDetails2.companyNumber || ' ') : ' ', 1),
              this.pdfTable('Kansalaisuus', offererDetails2.nationality || ' ', 1),
            ],
          );
        } else {
          offerer2.table.body.push(
            [
              this.pdfTable('Nimi', offererDetails2.name || ' ', 2),
              '',
              this.pdfTable('Hetu / Y-tunnus', this.agent ? (offererDetails2.ssn || ' ') : ' ', 1),
              this.pdfTable('Kansalaisuus', offererDetails2.nationality || ' ', 1),
            ],
          );
        }
        offerer2.table.body.push(
          [
            this.pdfTable('Osoite', `${offererDetails2.address || ''}${offererDetails2.zip ? ',' : ''} ${offererDetails2.zip || ''} ${offererDetails2.city || ''}`, 2),
            '',
            this.pdfTable('Sähköposti', offererDetails2.email || ' ', 1),
            this.pdfTable('Puhelin', offererDetails2.phone || ' ', 1),
          ],
        );

        if (!this.oldVersion) {
          offerer2.table.body.push(
            [
              this.pepTable(offererDetails2.pep, offererDetails2.pepDescription),
              '',
              '',
              '',
            ],
          );
        }

        const offerersWrapper = {
          unbreakable: true,
          table: {
            widths: ['*'],
            body: [
              [offerer1],
              [offerer2],
            ],
          },
          margin: [0, 5, 0, 2],
          layout: greyBorders(),
        };

        if (this.form.offerers.length > 2) {
          let s = 2;
          while (s < this.form.offerers.length) {
            let offererTable = {};
            if (this.form.offerers[s].isCompany) {
              let companyName = `${this.form.offerers[s].companyName} (${this.form.offerers[s].name})`;
              if (this.form.offerers[s].ssn) {
                companyName = `${this.form.offerers[s].companyName} (${this.form.offerers[s].name} ${this.form.offerers[s].ssn})`;
              }
              offererTable = {
                table: {
                  widths: ['*', '*', '*', '*'],
                  body: [
                    [
                      this.pdfTable('Nimi', companyName || ' ', 2),
                      '',
                      this.pdfTable('Hetu / Y-tunnus', this.agent ? (this.form.offerers[s].companyNumber || ' ') : ' ', 1),
                      this.pdfTable('Kansalaisuus', this.form.offerers[s].nationality || ' ', 1),
                    ],
                    [
                      this.pdfTable('Osoite', `${this.form.offerers[s].address || ''}${this.form.offerers[s].zip ? ',' : ''} ${this.form.offerers[s].zip || ''} ${this.form.offerers[s].city || ''}`, 2),
                      '',
                      this.pdfTable('Sähköposti', this.form.offerers[s].email || ' ', 1),
                      this.pdfTable('Puhelin', this.form.offerers[s].phone || ' ', 1),
                    ],
                  ],
                },
                margin: [0, 0, 0, 0],
                layout: 'noBorders',
              };
            } else {
              offererTable = {
                table: {
                  widths: ['*', '*', '*', '*'],
                  body: [
                    [
                      this.pdfTable('Nimi', this.form.offerers[s].name || ' ', 2),
                      '',
                      this.pdfTable('Hetu / Y-tunnus', this.agent ? (this.form.offerers[s].ssn || ' ') : ' ', 1),
                      this.pdfTable('Kansalaisuus', this.form.offerers[s].nationality || ' ', 1),
                    ],
                    [
                      this.pdfTable('Osoite', `${this.form.offerers[s].address}${this.form.offerers[s].zip ? ',' : ''} ${this.form.offerers[s].zip || ''} ${this.form.offerers[s].city || ''}`, 2),
                      '',
                      this.pdfTable('Sähköposti', this.form.offerers[s].email || ' ', 1),
                      this.pdfTable('Puhelin', this.form.offerers[s].phone || ' ', 1),
                    ],
                  ],
                },
                margin: [0, 0, 0, 0],
                layout: 'noBorders',
              };
            }
            if (!this.oldVersion) {
              offererTable.table.body.push(
                [
                  this.pepTable(this.form.offerers[s].pep, this.form.offerers[s].pepDescription),
                  '',
                  '',
                  '',
                ],
              );
            }
            offerersWrapper.table.body.push([offererTable]);
            s += 1;
          }
        }

        this.pdfContent.push(offerersWrapper);
        if (this.isShare) {
          this.pdfContent.push({
            unbreakable: true,
            table: {
              widths: ['25%', '25%', '*'],
              body: [
                [
                  {
                    text: '3. KAUPPASUMMA, MAKSAMINEN JA VELKAOSUUS',
                    margin: [-4, 0, 0, 2],
                    fontSize: 8.5,
                    color: textColor,
                    border: [false, false, false, false],
                    colSpan: 3,
                  },
                  '',
                  '',
                ],
                [
                  this.pdfTable('3.1 Velaton kauppahinta', this.form.offer !== '' ? `${this.form.offer.toString().replace('.', ',')} euroa` : ' ', 1),
                  this.pdfTable('3.2 Myyntihinta', this.form.offer !== '' ? `${this.sellingPrice.toString().replace('.', ',')} euroa` : ' ', 1),
                  this.pdfTable('3.3 Maksuaikataulu ja maksutapa', `${this.form.paymentMethod !== 'Ei valittu' ? this.form.paymentMethod : ''}${this.form.paymentMethod === 'Osamaksu' ? `\nKaupanteon yhteydessä maksetaan ${this.form.paymentDetail} €\nLoppuosa maksetaan ${this.paymentDateFormatted}.` : this.form.paymentMethod === 'Muu (anna selite)' ? `\n${this.form.paymentOther}` : '' }`, 1), // eslint-disable-line
                ],
                [
                  {
                    colSpan: 2,
                    rowSpan: 2,
                    text: [
                      '3.4 Velkaosuus\n',
                      {
                        text: this.debtDateText,
                        color: 'black',
                        fontSize: 8,
                      },
                    ],
                    fontSize: 7,
                    color: textColor,
                  },
                  '',
                  this.checkBox(this.form.debtPortionPayer === 2 ? 'X' : ' ', 'Ostaja ottaa velkaosuuden maksettavakseen', 1),
                ],
                [
                  '',
                  '',
                  this.checkBox(this.form.debtPortionPayer === 1 ? 'X' : ' ', 'Velkaosuus maksetaan pois kaupantekotilaisuudessa', 1),
                ],
                [
                  this.pdfTable('', { fontSize: 7, color: '#666666', text: this.debtPartText}, 3), // eslint-disable-line
                ],
              ],
            },
            margin: [0, 5, 0, 5],
            layout: greyBorders(),
          });
        } else {
          this.pdfContent.push({
            unbreakable: true,
            table: {
              widths: ['*', '*'],
              body: [
                [
                  {
                    text: '3. KAUPPAHINTA JA MAKSAMINEN',
                    margin: [-4, 0, 0, 2],
                    fontSize: 8.5,
                    color: textColor,
                    border: [false, false, false, false],
                    colSpan: 2,
                  },
                  '',
                ],
                [
                  this.pdfTable('3.1 Kauppahinta', this.form.offer !== '' ? `${this.form.offer.toString().replace('.', ',')} euroa` : ' ', 1),
                  this.pdfTable('3.2 Maksuaikataulu ja maksutapa', `${this.form.paymentMethod !== 'Ei valittu' ? this.form.paymentMethod : ''}${this.form.paymentMethod === 'Osamaksu' ? `\nKaupanteon yhteydessä maksetaan ${this.form.paymentDetail} €\nLoppuosa maksetaan ${this.paymentDateFormatted}.` : this.form.paymentMethod === 'Muu (anna selite)' ? `\n${this.form.paymentOther}` : '' }`, 1), // eslint-disable-line
                ],
              ],
            },
            margin: [0, 5, 0, 5],
            layout: greyBorders(),
          });
        }

        const emptyRow = () => [
          {
            text: ' ',
            colSpan: 2,
            fontSize: 2,
            margin: [0, -3, 0, -3],
            border: [false, true, false, false],
          },
          '',
        ];

        this.pdfContent.push({
          unbreakable: true,
          layout: greyBorders(),
          table: {
            widths: ['*', '*'],
            body: [
              [
                {
                  text: this.isShare ? '4. OIKEUKSIEN SIIRTYMINEN' : '4. OIKEUKSIEN JA VELVOLLISUUKSIEN SIIRTYMINEN',
                  margin: [-4, 3, 0, 2],
                  fontSize: 8.5,
                  color: textColor,
                  border: [false, false, false, false],
                  colSpan: 2,
                },
                '',
              ],
              [
                {
                  text: '4.1 OMISTUSOIKEUDEN SIIRTYMINEN',
                  colSpan: 2,
                  fontSize: 8.5,
                  color: textColor,
                },
                '',
              ],
              [
                this.checkBox(this.form.ownershipTransfer === 0 ? 'X' : ' ', 'Siirtyy kaupanteossa', 1, false),
                this.checkBox(this.form.ownershipTransfer === 1 ? 'X' : ' ', 'Muu (anna selite)', 1, false),
              ],
              [
                { text: ' ', fontSize: 7, border: [true, false, true, false] },
                { text: this.form.ownershipTransfer === 1 ? this.form.ownershipTransferDetail : ' ', fontSize: 7, border: [false, false, true, false] },
              ],
              emptyRow(),
              [
                {
                  text: '4.2 HALLINTAOIKEUDEN SIIRTYMINEN',
                  colSpan: 2,
                  fontSize: 8.5,
                  color: textColor,
                },
                '',
              ],
              [
                this.checkBox(this.form.possessionTransfer === 0 ? 'X' : ' ', 'Siirtyy kaupanteossa', 1, false),
                this.checkBox(this.form.possessionTransfer === 1 ? 'X' : ' ', 'Muu (anna selite)', 1, false),
              ],
              [
                { text: ' ', fontSize: 7, border: [true, false, true, false] },
                { text: this.form.possessionTransfer === 1 ? this.form.possessionTransferDetail : ' ', fontSize: 7, border: [false, false, true, false] },
              ],
              emptyRow(),
              [
                {
                  text: '4.3 VIIVÄSTYSKORVAUS',
                  colSpan: 2,
                  fontSize: 8.5,
                  color: textColor,
                },
                '',
              ],
              [
                this.pdfTable('', { fontSize: 8, color: '#666666', text: `Mikäli vapautuminen viivästyy myyjästä johtuvasta syystä, myyjä maksaa viivästyskorvauksena kultakin alkavalta viivästysviikolta ${this.form.paymentDelay !== '' ? this.form.paymentDelay : '_________'} euroa\n\n`}, 2), // eslint-disable-line
              ],
              emptyRow(),
              [
                {
                  text: [
                    '4.4 VASTUU MAKSUISTA - ',
                    { text: this.expenseText, fontSize: 8 },
                  ],
                  colSpan: 2,
                  fontSize: 8.5,
                  color: textColor,
                },
                '',
              ],
              [
                this.checkBox(this.form.expense === 0 ? 'X' : ' ', 'Hallintaoikeuden siirtymisestä lähtien', 1, false),
                this.checkBox(this.form.expense === 1 ? 'X' : ' ', 'Muu (anna selite)', 1, false),
              ],
              [
                { text: ' ', fontSize: 7, border: [true, false, true, true] },
                { text: this.form.expense === 1 ? this.form.expenseDetail : ' ', fontSize: 7, border: [true, false, true, true] },
              ],
            ],
          },
        });

        if (this.propertyType === 0) {
          this.pdfContent.push({
            unbreakable: true,
            layout: greyBorders(),
            table: {
              widths: ['*', '*'],
              body: [
                emptyRow(),
                [
                  {
                    text: '4.5 VAARANVASTUUN SIIRTYMINEN OSTAJALLE',
                    colSpan: 2,
                    fontSize: 8.5,
                    color: textColor,
                  },
                  '',
                ],
                [
                  this.checkBox(this.form.risk === 0 ? 'X' : ' ', 'Omistusoikeuden siirtymisestä lähtien', 1, false),
                  this.checkBox(this.form.risk === 1 ? 'X' : ' ', 'Muu (anna selite)', 1, false),
                ],
                [
                  { text: ' ', fontSize: 7, border: [true, false, true, true] },
                  { text: this.form.risk === 1 ? this.form.riskDetail : ' ', fontSize: 7, border: [true, false, true, true] },
                ],
              ],
            },
          });
        }

        this.pdfContent.push({
          unbreakable: true,
          layout: greyBorders(),
          table: {
            widths: ['*', '*'],
            body: [
              [{
                text: '5. TARJOUKSEN EHDOT',
                margin: [-4, 4, 0, 1],
                fontSize: 8.5,
                color: textColor,
                border: [false, false, false, true],
                colSpan: 2,
              }, ''],
              [
                {
                  text: '5.1 VASTUUNRAJOITUSLAUSEKKEET',
                  colSpan: 2,
                  fontSize: 8.5,
                  color: textColor,
                },
                '',
              ],
              [
                {
                  table: {
                    widths: ['*', '*', '*'],
                    body: [
                      [
                        this.checkBox(this.form.conditions.loan ? 'X' : ' ', 'Lainan saanti', 1, false, true),
                        this.checkBox(this.form.conditions.sell ? 'X' : ' ', 'Oman asunnon myynti', 1, false, true),
                        this.checkBox(this.form.conditions.permit ? 'X' : ' ', 'Viranomaisen lupa', 1, false, true),
                      ],
                      [
                        this.checkBox(this.form.conditions.humidity ? 'X' : ' ', 'Kosteusmittaus', 1, false, true),
                        this.checkBox(this.form.conditions.conditiononly ? 'X' : ' ', 'Kuntotarkastus', 1, false, true),
                        this.form.conditions.condition ? this.checkBox('X', 'Kosteusmittaus / kuntotarkastus', 1, false, true) : { text: ' ', border: [false, false, false, false] },
                      ],
                    ],
                  },
                  colSpan: 2,
                  margin: [0, 5, 0, -5],
                },
                '',
              ],
              [
                this.pdfTable({ fontSize: 7, text: this.ifOccurs }, '', 2), // eslint-disable-line
                '',
              ],
              [
                this.checkBox(this.form.conditions.marketing ? 'X' : ' ', 'Kohde pysyy markkinoinnissa ja myyjällä on oikeus hyväksyä kolmannen osapuolen tarjous ilman sanktioita', 2, true, false),
                '',
              ],
            ],
          },
          margin: [0, 5, 0, 5],
        });

        const conditions = {
          unbreakable: true,
          layout: greyBorders(),
          table: {
            widths: ['*', '*'],
            body: [
              [
                {
                  text: '5.2 VARAINSIIRTOVERO',
                  colSpan: 2,
                  fontSize: 8.5,
                  color: textColor,
                },
                '',
              ],
            ],
          },
          margin: [0, 5, 0, 5],
        };
        let assetTransfer1 = {};
        let assetTransfer2 = {};
        if (this.form.offerers[0]) { [assetTransfer1] = this.form.offerers; }
        if (this.form.offerers[1]) { [, assetTransfer2] = this.form.offerers; }

        let assetname1 = assetTransfer1.name ? assetTransfer1.name : 'nimi: ________';
        if (assetTransfer1.isCompany) {
          assetname1 = assetTransfer1.companyName ? assetTransfer1.companyName : 'nimi: ________';
        }

        const assetTransferWrapper1 = {
          table: {
            widths: ['*'],
            body: [
              [
                { text: assetname1, fontSize: 8, margin: [-5, 3, 0, 2] },
              ],
              [
                this.checkBox(assetTransfer1.name && assetTransfer1.assetTransfer === false ? 'X' : ' ', this.isShare ? 'maksaa varainsiirtoveron kaupantekotilaisuudessa' : 'maksaa varainsiirtoveron', 1, false, true),
              ],
              [
                this.checkBox(assetTransfer1.assetTransfer === true ? 'X' : ' ', 'ei varainsiirtoverovelvollinen', 1, false, true),
              ],
            ],
          },
          margin: [5, 0, 0, -4],
          layout: 'noBorders',
        };

        let assetname2 = assetTransfer2.name ? assetTransfer2.name : 'nimi: ________';
        if (assetTransfer2.isCompany) {
          assetname2 = assetTransfer2.companyName ? assetTransfer2.companyName : 'nimi: ________';
        }

        const assetTransferWrapper2 = {
          table: {
            widths: ['*'],
            body: [
              [
                { text: assetname2, fontSize: 8, margin: [-5, 3, 0, 2] },
              ],
              [
                this.checkBox(assetTransfer2.name && assetTransfer2.assetTransfer !== true ? 'X' : ' ', this.isShare ? 'maksaa varainsiirtoveron kaupantekotilaisuudessa' : 'maksaa varainsiirtoveron', 1, false, true),
              ],
              [
                this.checkBox(assetTransfer2.assetTransfer === true ? 'X' : ' ', 'ei varainsiirtoverovelvollinen', 1, false, true),
              ],
            ],
          },
          margin: [5, 0, 0, -4],
          layout: 'noBorders',
        };

        const dynamicAssetTransfer = offerer => (
          {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: offerer.isCompany
                      ? offerer.companyName
                      : offerer.name,
                    fontSize: 8,
                    margin: [-5, 3, 0, 2],
                  },
                ],
                [
                  this.checkBox(offerer.assetTransfer !== true ? 'X' : ' ', this.isShare ? 'maksaa varainsiirtoveron kaupantekotilaisuudessa' : 'maksaa varainsiirtoveron', 1, false, true),
                ],
                [
                  this.checkBox(offerer.assetTransfer === true ? 'X' : ' ', 'ei varainsiirtoverovelvollinen', 1, false, true),
                ],
              ],
            },
            margin: [5, 0, 0, -4],
            layout: 'noBorders',
          });

        conditions.table.body.push(
          [
            assetTransferWrapper1,
            assetTransferWrapper2,
          ],
        );

        if (this.form.offerers.length > 2) {
          let x = 2;
          let assetArray = [' ', ' '];
          while (x < this.form.offerers.length) {
            assetArray[x % 2 === 0 ? 0 : 1] = dynamicAssetTransfer(this.form.offerers[x]);
            if (x % 2 !== 0 || x + 1 === this.form.offerers.length) {
              conditions.table.body.push(
                assetArray,
              );
            }
            if (x % 2 !== 0) {
              assetArray = [' ', ' '];
            }
            x += 1;
          }
        }

        conditions.table.body.push(
          [
            this.pdfTable({ fontSize: 7, text: 'Mikäli varainsiirtoverovapautta koskevat edellytykset eivät kuitenkaan täyty, tai ne täyttyvät myöhemmin, ostaja vastaa tästä kaupasta aiheutuvasta varainsiirtoverosta.' }, '', 2), // eslint-disable-line
            '',
          ],
        );

        this.pdfContent.push(conditions);

        this.pdfContent.push({
          unbreakable: true,
          layout: greyBorders(),
          table: {
            widths: ['*', '*'],
            body: [
              [
                {
                  text: '5.3 MUUT EHDOT',
                  colSpan: 2,
                  fontSize: 8.5,
                  color: textColor,
                },
                '',
              ],
              [
                { text: this.form.otherConditions !== '' ? this.form.otherConditions.substring(0, 1000) : '\n\n\n\n\n', colSpan: 2, fontSize: 7 },
                '',
              ],
              [
                this.pdfTable({ fontSize: 7, text: this.aboutConditions }, '', 2), // eslint-disable-line
                '',
              ],
            ],
          },
        });

        if (!this.oldVersion) {
          this.pdfContent.push({
            unbreakable: true,
            margin: [0, 5, 0, 0],
            layout: greyBorders(),
            table: {
              widths: ['*', '*'],
              body: [
                [
                  {
                    text: '5.4 LIITTEET',
                    colSpan: 2,
                    fontSize: 8.5,
                    color: textColor,
                  },
                  '',
                ],
                [
                  { text: this.form.selectedAttachments, colSpan: 2, fontSize: 7 },
                  '',
                ],
              ],
            },
          });
        }

        const fee = {
          text: this.propertyType === 0 ? '6. VAKIOKORVAUS (SOPIMUSSAKKO) TAI MAKSETTU KÄSIRAHA JA KORVAUS KAUPASTA VETÄYTYMISESTÄ' : '6. VAKIOKORVAUS (SOPIMUSSAKKO) TAI MAKSETTU KÄSIRAHA',
          margin: [0, 5, 0, -2],
          fontSize: 8.5,
          color: textColor,
        };

        if (this.propertyType === 2) {
          fee.margin = [0, 30, 0, -2];
        }

        this.pdfContent.push(fee);

        const depositSelection = this.form.deposit === this.form.depositValues[0];

        const deposit = {
          table: {
            widths: ['*', '*'],
            body: [
              [
                this.checkBox(depositSelection ? 'X' : ' ', `6.1 Vakiokorvaus ${(this.form.depositInEuros > 0 && depositSelection) ? this.form.depositInEuros.replace('.', ',') : '                        '} euroa`, 2, false),
                '',
              ],
              [
                {
                  text: this.deposit1text,
                  color: '#555555',
                  colSpan: 2,
                  fontSize: 6.5,
                  border: [true, false, true, false],
                  margin: [0, -5, 0, 3],
                },
                '',
              ],
              [
                this.checkBox(depositSelection === false ? 'X' : ' ', `6.2 Käsiraha ${(this.form.depositInEuros > 0 && !depositSelection) ? this.form.depositInEuros.replace('.', ',') : '                        '} euroa`, 2, false),
                '',
              ],
              [
                {
                  text: this.deposit2text,
                  color: '#555555',
                  colSpan: 2,
                  fontSize: 6.5,
                  border: [true, false, true, true],
                  margin: [0, -5, 0, 3],
                },
                '',
              ],
            ],
          },
          layout: greyBorders(),
          margin: [0, 5, 0, 5],
        };

        if (this.propertyType === 0 && !this.createdAfterLawChange) {
          deposit.table.body.push(
            [
              {
                text: '6.3 Korvaus kaupasta vetäytymisestä',
                fontSize: 7,
                margin: [0, 0, 0, 0],
                border: [true, true, true, false],
                color: '#666666',
                colSpan: 2,
              },
              '',
            ],
          );
          deposit.table.body.push(
            [
              {
                text: this.deposit3,
                color: '#555555',
                colSpan: 2,
                fontSize: 6.5,
                border: [true, false, true, true],
                margin: [0, -2, 0, 3],
              },
              '',
            ],
          );
        }

        this.pdfContent.push(deposit);
        this.pdfContent.push({
          text: '7. TARJOUKSEN VOIMASSAOLO',
          margin: [0, 2, 0, -2],
          fontSize: 8.5,
          color: textColor,
        });
        const offerValid = {
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                this.pdfTable('7.1 Päivämäärään asti', this.offerValidUntilDateFormatted, 1),
                this.pdfTable('7.2 Kellonaikaan asti', this.form.offerValidUntilTime, 1),
                this.pdfTable('7.3 Kauppakirjat allekirjoitettava viimeistään', this.signingDateFormatted, 1),
              ],
            ],
          },
          margin: [0, 5, 0, 5],
          layout: greyBorders(),
        };
        this.pdfContent.push(offerValid);
        this.pdfContent.push({ fontSize: 7, color: '#666666', text: 'Mikäli myyjä hyväksyy tarjouksen, syntyy tarjouksen tekijän ja myyjän välille sitova sopimussuhde. Tarjous katsotaan hyväksytyksi sillä hetkellä, kun välitysliikkeen edustaja tai tarjouksen tekijä on saanut tiedon tarjouksen hyväksymisestä tarjouksen vastaanottajalta.' });
        this.pdfContent.push({
          text: '8. VÄLITYSLIIKKEEN TIEDOT JA KUITTAUS',
          margin: [0, 6, 0, -2],
          fontSize: 8.5,
          color: textColor,
        });
        const companyDetails = {
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                this.pdfTable('8.1 Välitysliikkeen toiminimi', this.property.companyName, 1),
                this.pdfTable('8.2 Osoite', this.property.companyAddress, 1),
                this.pdfTable('8.3 Y-tunnus', this.property.companyVat, 1),
              ],
              [
                this.pdfTable('8.4 Paikka ja aika', `${this.property.companyCity}, ${moment(this.createDate, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm')}`, 1),
                this.pdfTable('8.5 Välitysliikkeen kuittaus', `Sähköinen - ${this.signingAgent}`, 2),
                '',
              ],
            ],
          },
          layout: greyBorders(),
          margin: [0, 5, 0, 5],
        };
        this.pdfContent.push(companyDetails);

        // Get all signatures
        let signatureIndex = 0;
        const res = await apiGet(`nets/allsignatures/${this.$route.params.id}/${this.$route.params.offerId}`);
        const allSignatures = res.result;
        const firstSigner = allSignatures.find(s => +s.response_index === 0
          && +s.offerer_index === 0);
        const secondSigner = allSignatures.find(s => +s.response_index === 0
          && +s.offerer_index === 1);

        const identification = [
          {
            table: {
              widths: ['*', 65, 75, 55, '*', '*'],
              body: [
                [
                  {
                    text: 'Tarjouksen tekijän tunnistus (9.2)',
                    fontSize: 6,
                    margin: [0, 0, 0, 0],
                    color: textColor,
                  },
                  this.checkBox(' ', 'Ajokortti', 1, true, true, true),
                  this.checkBox(' ', 'Henkilökortti', 1, true, true, true),
                  this.checkBox(' ', 'Passi', 1, true, true, true),
                  this.checkBox(' ', 'Kuvallinen henkilökortti', 1, true, true, true),
                  this.checkBox(firstSigner && firstSigner.signature ? 'X' : ' ', 'Sähköinen tunnistautuminen', 1, true, true, true),
                ],
                [
                  {
                    text: 'Tarjouksen tekijän tunnistus (9.3)',
                    fontSize: 6,
                    margin: [0, 0, 0, 0],
                    color: textColor,
                  },
                  this.checkBox(' ', 'Ajokortti', 1, true, true, true),
                  this.checkBox(' ', 'Henkilökortti', 1, true, true, true),
                  this.checkBox(' ', 'Passi', 1, true, true, true),
                  this.checkBox(' ', 'Kuvallinen henkilökortti', 1, true, true, true),
                  this.checkBox(secondSigner && secondSigner.signature ? 'X' : ' ', 'Sähköinen tunnistautuminen', 1, true, true, true),
                ],
              ],
            },
            colSpan: 3,
            margin: [0, 2, 0, -5],
            layout: 'noBorders',
          },
          '',
          '',
        ];

        const chunk = (str, n) => {
          const ret = [];
          let idx;
          let len;

          for (idx = 0, len = str.length; idx < len; idx += n) {
            ret.push(str.substr(idx, n));
          }

          return ret;
        };

        const signatures = {
          unbreakable: true,
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                {
                  text: '9. TARJOUKSENTEKIJÄN ALLEKIRJOITUKSET',
                  margin: [-4, 3, 0, 2],
                  fontSize: 8.5,
                  color: textColor,
                  border: [false, false, false, false],
                  colSpan: 3,
                },
                '',
                '',
              ],
              [
                this.pdfTable('9.1 Paikka ja aika', this.offerSignedDate, 1),
                this.pdfTable('9.2 Allekirjoitus ja nimenselvennys', firstSigner ? firstSigner.name : ' ', 1),
                this.pdfTable('9.3 Allekirjoitus ja nimenselvennys', secondSigner ? secondSigner.name : ' ', 1),
              ],
            ],
          },
          margin: [0, 5, 0, 5],
          layout: greyBorders(),
        };

        const identificationStrings = {
          table: {
            widths: ['*'],
            body: [],
          },
          margin: [0, 5, 0, 5],
          layout: greyBorders(),
        };

        if (firstSigner) {
          let signatureString = chunk(firstSigner.signature, 175).join('\n');
          if (firstSigner.signed_at) {
            signatureString = `${signatureString}\nAikaleima: ${this.formatDateTime(firstSigner.signed_at)}`;
          }
          identificationStrings.table.body.push([this.pdfTable('Tunniste (9.2) - Nets / NO 996345734 MVA', signatureString, 1, 1, true)]);
        }
        if (secondSigner) {
          let signatureString = chunk(secondSigner.signature, 175).join('\n');
          if (secondSigner.signed_at) {
            signatureString = `${signatureString}\nAikaleima: ${this.formatDateTime(secondSigner.signed_at)}`;
          }
          identificationStrings.table.body.push([this.pdfTable('Tunniste (9.3) - Nets / NO 996345734 MVA', signatureString, 1, 1, true)]);
        }

        if (this.form.offerers.length > 2) {
          let t = 4;
          let signerInRow = 0;
          let row = 2;
          while ((t - 2) < this.form.offerers.length) {
            const signedofferer = allSignatures.find(s => s.response_index === '0' && +s.offerer_index === t - 2); // eslint-disable-line
            identification[0].table.body.push(
              [
                {
                  text: `Tarjouksen tekijän tunnistus (9.${t})`,
                  fontSize: 6,
                  margin: [0, 0, 0, 0],
                  color: textColor,
                },
                this.checkBox(' ', 'Ajokortti', 1, true, true, true),
                this.checkBox(' ', 'Henkilökortti', 1, true, true, true),
                this.checkBox(' ', 'Passi', 1, true, true, true),
                this.checkBox(' ', 'Kuvallinen henkilökortti', 1, true, true, true),
                this.checkBox(signedofferer ? 'X' : ' ', 'Sähköinen tunnistautuminen', 1, true, true, true),
              ],
            );
            if (signedofferer) {
              let signatureString = chunk(signedofferer.signature, 175).join('\n');
              if (signedofferer.signed_at) {
                signatureString = `${signatureString}\nAikaleima: ${this.formatDateTime(signedofferer.signed_at)}`;
              }
              identificationStrings.table.body.push([this.pdfTable(`Tunniste (9.${t}) - Nets / NO 996345734 MVA`, signatureString, 1, 1, true)]);
            }
            if (signerInRow === 0 && signedofferer) {
              signatures.table.body.push([this.pdfTable(`9.${t} Allekirjoitus`, `${signedofferer.name}`, 1), ' ', ' ']);
            } else if (signedofferer) {
              if (signatures.table.body[row]) {
                signatures.table.body[row][signerInRow] = this.pdfTable(`9.${t} Allekirjoitus`, `${signedofferer.name}`, 1);
              }
            }
            signerInRow += 1;
            if (signerInRow > 2) {
              signerInRow = 0;
              row += 1;
            }
            t += 1;
          }
        }

        signatures.table.body.push(
          [
            {
              fontSize: 7,
              text: 'Allekirjoituksellani vakuutan antaneeni oikeat tiedot, sekä olen huolella tutustunut sopimukseen ja ymmärtänyt sopimuksen sisällön.', // eslint-disable-line
              colSpan: 3,
              color: '#666666',
            },
            '',
            '',
          ],
        );
        signatures.table.body.push(identification);
        this.pdfContent.push(signatures);
        if (identificationStrings.table.body.length > 0) {
          this.pdfContent.push(identificationStrings);
        }

        // SELLER RESPONSE STARTS

        const sellerIdentification = (number, signers) => {
          const idWrapper = [
            {
              table: {
                widths: ['*', 65, 75, 55, '*', '*'],
                body: [],
              },
              colSpan: 3,
              margin: [0, 2, 0, -5],
              layout: 'noBorders',
            },
            '',
            '',
          ];

          let i = 0;
          while (i < signers.length) {
            idWrapper[0].table.body.push([
              {
                text: `Tunnistautuminen (${number}.${7 + i})`,
                fontSize: 6,
                margin: [0, 0, 0, 0],
                color: textColor,
              },
              this.checkBox(' ', 'Ajokortti', 1, true, true, true),
              this.checkBox(' ', 'Henkilökortti', 1, true, true, true),
              this.checkBox(' ', 'Passi', 1, true, true, true),
              this.checkBox(' ', 'Kuvallinen henkilökortti', 1, true, true, true),
              this.checkBox(!signers[i].signature ? ' ' : 'X', 'Sähköinen tunnistautuminen', 1, true, true, true),
            ]);
            i += 1;
          }

          return idWrapper;
        };

        const sellersResponse = {
          unbreakable: true,
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                {
                  text: '10. MYYJÄN / YRITYKSEN NIMENKIRJOITUSOIKEUDELLISEN VASTAUS',
                  margin: [-4, 3, 0, 2],
                  fontSize: 8.5,
                  color: textColor,
                  border: [false, false, false, false],
                  colSpan: 3,
                },
                '',
                '',
              ],
              [
                this.checkBox(this.form.responseOffer.choice === 0 ? 'X' : ' ', '10.1 Hyväksymme tarjouksen', 1, false),
                this.checkBox(this.form.responseOffer.choice === 1 ? 'X' : ' ', '10.2 Hyväksymme tarjouksen seuraavin muutoksin', 2, false),
                '',
              ],
              [
                this.checkBox(this.form.responseOffer.choice === 2 ? 'X' : ' ', '10.3 Hylkäämme tarjouksen', 1, false),
                {
                  text: '\n\n\n\n',
                  fontSize: 7,
                  border: [true, false, true, false],
                  colSpan: 2,
                },
                '',
              ],
              [
                this.pdfTable('10.3 Vastatarjous voimassa päivämäärään asti', this.formatDate(this.form.responseOffer.offerValidUntilDate) || ' ', 1),
                this.pdfTable('10.4 Kellonaikaan asti', this.form.responseOffer.offerValidUntilTime ? this.form.responseOffer.offerValidUntilTime : ' ', 1),
                this.pdfTable('10.5 Kauppakirjat allekirjoitetaan viimeistään', this.formatDate(this.form.responseOffer.signingDate) || ' ', 1),
              ],
              [
                this.pdfTable('10.6 Paikka ja aika', ' ', 1),
                this.pdfTable('10.7 Allekirjoitus ja nimenselvennys', ' ', 1),
                this.pdfTable('10.8 Allekirjoitus ja nimenselvennys', ' ', 1),
              ],
              [
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [{
                        text: '10.9 Osoite',
                        fontSize: 7,
                        margin: [0, 0, 0, 0],
                        color: '#666666',
                      }],
                      [{ text: ' ', fontSize: 9, margin: [0, -3, 0, 0] }],
                    ],
                  },
                  layout: 'noBorders',
                  border: [true, false, true, false],
                  margin: [0, -2, 0, -2],
                },
                this.pdfTable('Henkilötunnus (10.7)', ' ', 1),
                this.pdfTable('Henkilötunnus (10.8)', ' ', 1),
              ],
              [
                {
                  text: ' ',
                  fontSize: 7,
                  border: [true, false, true, false],
                },
                this.pdfTable('Puhelinnumero (10.7)', ' ', 1),
                this.pdfTable('Puhelinnumero (10.8)', ' ', 1),
              ],
              [
                {
                  text: ' ',
                  fontSize: 7,
                  border: [true, false, true, true],
                },
                this.pdfTable('Sähköposti (10.7)', ' ', 1),
                this.pdfTable('Sähköposti (10.8)', ' ', 1),
              ],
            ],
          },
          margin: [0, 5, 0, 5],
          layout: greyBorders(),
        };

        const offererResponse = _.cloneDeep(sellersResponse);

        offererResponse.table.body = offererResponse.table.body.slice(0, -3);

        if (this.form.responseOffer.exceptionText) {
          this.pdfContent.push({
            table: {
              body: [
                [{
                  text: this.form.responseOffer.exceptionText.substring(0, 400),
                  fontSize: 8,
                  margin: [0, 0, 5, 0],
                }],
              ],
            },
            layout: 'noBorders',
            absolutePosition: { x: 208, y: 527 },
            fontSize: 6.5,
          });
        }

        // SELLER RESPONSE ENDS

        // DYNAMIC RESPONSES
        let orderNumber = 10;
        const allResponses = [
          ...this.responses,
        ];

        const unsignedResponse = await apiGet(`properties/unsignedresponse/${this.$route.params.offerId}`);
        if (unsignedResponse.result && unsignedResponse.result.fields) {
          const resp = JSON.parse(unsignedResponse.result.fields);
          resp.unsig = true;
          allResponses.push(resp);
        }

        if (!allResponses.length) {
          this.pdfContent.push(sellersResponse);
        }

        allResponses.forEach((response) => {
          signatureIndex += 1;
          const sellerIdentificationStrings = {
            table: {
              widths: ['*'],
              body: [],
            },
            margin: [0, 5, 0, 5],
            layout: greyBorders(),
          };

          const pdfBlock = (response.signerRole === 'seller' && orderNumber < 11) ? _.cloneDeep(sellersResponse) : _.cloneDeep(offererResponse);

          pdfBlock.table.body[0][0].text = `${orderNumber}. ${response.signerRole === 'seller' ? 'MYYJÄN / YRITYKSEN NIMENKIRJOITUSOIKEUDELLISEN' : 'TARJOAJAN'} VASTAUS`; // eslint-disable-line
          pdfBlock.table.body[1][0] = this.checkBox(response.choice === 0 ? 'X' : ' ', `${orderNumber}.1 Hyväksymme tarjouksen`, 1, false); // eslint-disable-line
          pdfBlock.table.body[1][1] = this.checkBox(response.choice === 1 ? 'X' : ' ', `${orderNumber}.2 Hyväksymme tarjouksen seuraavin muutoksin`, 2, false); // eslint-disable-line
          pdfBlock.table.body[2][0] = this.checkBox(response.choice === 2 ? 'X' : ' ', `${orderNumber}.3 Hylkäämme tarjouksen`, 1, false); // eslint-disable-line
          if (response.choice === 1) {
            pdfBlock.table.body[2][1] = {
              text: response.exceptionText,
              fontSize: 7,
              border: [true, false, true, false],
              colSpan: 2,
            };
          }
          pdfBlock.table.body[3][0] = this.pdfTable(`${orderNumber}.3 Vastatarjous voimassa päivämäärään asti`, response.choice !== 1 ? ' ' : this.formatDate(response.offerValidUntilDate) || ' ', 1); // eslint-disable-line
          pdfBlock.table.body[3][1] = this.pdfTable(`${orderNumber}.4 Kellonaikaan asti`, response.choice !== 1 ? ' ' : response.offerValidUntilTime ? response.offerValidUntilTime : ' ', 2); // eslint-disable-line
          pdfBlock.table.body[3][2] = ' '; // eslint-disable-line
          pdfBlock.table.body[4][0] = this.pdfTable(`${orderNumber}.6 Paikka ja aika`, (response.signed_date ? this.formatDateTime(response.signed_date) : ' ') || ' ', 1); // eslint-disable-line
          let signers = 1;
          let signerOrder = 1;
          let row = 4;
          let responseSigners = this.form.offerers;
          if (response.signerRole === 'seller') {
            responseSigners = this.sellers;
          }
          if (responseSigners.length === 1) {
            pdfBlock.table.body[4][2] = ' ';
          }
          let signerIndex = 0;
          const responseIdArray = [];
          responseSigners.forEach((sig) => {
            const signer = _.cloneDeep(sig);
            const signerSignature = allSignatures.find(s => +s.response_index
              === +signatureIndex
              && +s.offerer_index === +signerIndex);
            if (signers === 0) {
              pdfBlock.table.body.push([this.pdfTable(`${orderNumber}.${signerOrder + 6} Allekirjoitus`, `${!signerSignature ? ' ' : signerSignature.name}`, 1), ' ', ' ']); // eslint-disable-line
            } else {
              pdfBlock.table.body[row][signers] = this.pdfTable(`${orderNumber}.${signerOrder + 6} Allekirjoitus`, `${!signerSignature ? ' ' : signerSignature.name}`, 1); // eslint-disable-line
            }
            // if (!response.unsig) {
            if (signerSignature) {
              let signatureString = chunk(signerSignature.signature, 175).join('\n');
              if (signerSignature.signed_at) {
                signatureString = `${signatureString}\nAikaleima: ${this.formatDateTime(signerSignature.signed_at)}`;
              }
              sellerIdentificationStrings.table.body.push([this.pdfTable(
                `Tunniste (${orderNumber}.${signerOrder + 6}) - Nets / NO 996345734 MVA`,
                signatureString, 1, 1, true,
              )]);
              signer.signature = signerSignature.signature;
            }
            signerIndex += 1;
            // }
            signers += 1;
            signerOrder += 1;
            if (signers > 2) {
              signers = 0;
              row += 1;
            }
            responseIdArray.push(signer);
          });
          const sIdentification = sellerIdentification(
            orderNumber,
            responseIdArray,
          );
          pdfBlock.table.body.push(sIdentification);

          this.pdfContent.push(pdfBlock);
          if (sellerIdentificationStrings.table.body.length > 0) {
            this.pdfContent.push(sellerIdentificationStrings);
          }
          orderNumber += 1;
          // if (!response.unsig) {
          //   signatureIndex += 1;
          // }
        });

        if (!this.responses) {
          this.pdfContent.push({
            text: '11. TARJOUKSENTEKIJÄN VASTAUS VASTATARJOUKSEEN',
            margin: [0, 3, 0, -2],
            fontSize: 8.5,
            color: textColor,
          });

          const offererSecondIdentification = [
            {
              table: {
                widths: ['*', 65, 75, 55, '*', '*'],
                body: [
                  [
                    {
                      text: 'Tarjouksen tekijän tunnistus (11.7)',
                      fontSize: 6,
                      margin: [0, 0, 0, 0],
                      color: textColor,
                    },
                    this.checkBox(this.form.identification5.drivingLicense ? 'X' : ' ', 'Ajokortti', 1, true, true, true),
                    this.checkBox(this.form.identification5.identityCard ? 'X' : ' ', 'Henkilökortti', 1, true, true, true),
                    this.checkBox(this.form.identification5.passPort ? 'X' : ' ', 'Passi', 1, true, true, true),
                    this.checkBox(this.form.identification5.identityCardWithImage ? 'X' : ' ', 'Kuvallinen henkilökortti', 1, true, true, true),
                    this.checkBox(this.form.identification5.electronicSignature ? 'X' : ' ', 'Sähköinen tunnistautuminen', 1, true, true, true),
                  ],
                  [
                    {
                      text: 'Tarjouksen tekijän tunnistus (11.8)',
                      fontSize: 6,
                      margin: [0, 0, 0, 0],
                      color: textColor,
                    },
                    this.checkBox(this.form.identification6.drivingLicense ? 'X' : ' ', 'Ajokortti', 1, true, true, true),
                    this.checkBox(this.form.identification6.identityCard ? 'X' : ' ', 'Henkilökortti', 1, true, true, true),
                    this.checkBox(this.form.identification6.passPort ? 'X' : ' ', 'Passi', 1, true, true, true),
                    this.checkBox(this.form.identification6.identityCardWithImage ? 'X' : ' ', 'Kuvallinen henkilökortti', 1, true, true, true),
                    this.checkBox(this.form.identification6.electronicSignature ? 'X' : ' ', 'Sähköinen tunnistautuminen', 1, true, true, true),
                  ],
                ],
              },
              colSpan: 3,
              margin: [0, 2, 0, -5],
              layout: 'noBorders',
            },
            '',
            '',
          ];

          const responseResponse = {
            table: {
              widths: ['*', '*', '*'],
              body: [
                [
                  this.checkBox(false ? 'X' : ' ', '11.1 Hyväksymme tarjouksen', 1, false), // eslint-disable-line
                  this.checkBox(false ? 'X' : ' ', '11.2 Hyväksymme tarjouksen seuraavin muutoksin', 2, false), // eslint-disable-line
                  '',
                ],
                [
                  { text: '\n\n\n', fontSize: 7, border: [true, false, true, false] },
                  {
                    text: '\n\n\n',
                    fontSize: 7,
                    border: [true, false, true, false],
                    colSpan: 2,
                  },
                  '',
                ],
                [
                  this.pdfTable('11.3 Tarjous voimassa päivämäärään asti', ' ', 1),
                  this.pdfTable('11.4 Kellonaikaan asti', ' ', 1),
                  this.pdfTable('11.5 Kauppakirjat allekirjoitetaan viimeistään', ' ', 1),
                ],
                [
                  this.pdfTable('11.6 Paikka ja aika', ' ', 1),
                  this.pdfTable('11.7 Allekirjoitus ja nimenselvennys', ' ', 1),
                  this.pdfTable('11.8 Allekirjoitus ja nimenselvennys', ' ', 1),
                ],
                offererSecondIdentification,
              ],
            },
            layout: greyBorders(),
            margin: [0, 5, 0, 5],
          };
          this.pdfContent.push(responseResponse);
        }

        // KAUPANVAHVISTAJA
        if (this.propertyType === 0) {
          if (orderNumber === 10) {
            orderNumber = 11;
          }
          this.pdfContent.push(
            {
              unbreakable: true,
              table: {
                widths: ['*', '*', '*'],
                body: [
                  [
                    {
                      text: `${orderNumber} KAUPANVAHVISTAJAN TODISTUS`,
                      margin: [-4, 3, 0, 2],
                      fontSize: 8.5,
                      color: textColor,
                      colSpan: 3,
                      border: [false, false, false, true],
                    },
                    '',
                    '',
                  ],
                  [
                    {
                      color: textColor, text: `${orderNumber}.1 Julkisena kaupanvahvistajana todistan, että:\nLuovuttajana:\nsekä luovutuksensaajana:\novat allekirjoittaneet tämän esisopimuksen sekä olleet yhtä aikaa läsnä esisopimusta allekirjoittaessa.\nOlen tarkastanut osapuolien henkilöllisyyden ja todennut, että esisopimus on tehty maakaaren 2 luvun 1§:n mukaisesti.`, fontSize: 7, colSpan: 2, rowSpan: 2,
                    },
                    '',
                    this.pdfTable(`${orderNumber}.2 Virka-asema / käräjäoikeuden määräämä`, ' ', 1),
                  ],
                  [
                    '',
                    '',
                    this.pdfTable(`${orderNumber}.3 Kaupanvahvistajan tunnus`, ' ', 1),
                  ],
                  [
                    this.pdfTable(`${orderNumber}.4 Paikka ja aika`, ' ', 1),
                    this.pdfTable(`${orderNumber}.5 Kaupanvahvistajan allekirjoitus ja nimenselvennys`, ' ', 2),
                    '',
                  ],
                  [
                    this.pdfTable(`${orderNumber}.6 Myyjän allekirjoitus ja nimenselvennys (Esisopimus)`, ' ', 1),
                    this.pdfTable(`${orderNumber}.7 Tarjouksentekijän allekirjoitus ja nimenselvennys (Esisopimus)`, ' ', 2),
                    '',
                  ],
                ],
              },
              layout: greyBorders(),
              margin: [0, 5, 0, 5],
            },
          );
        }

        this.pdfContent.push({
          unbreakable: true,
          table: {
            body: [
              [{
                text: 'LISÄTIEDOT',
                margin: [0, 3, 0, -2],
                fontSize: 8.5,
                color: textColor,
                border: [true, true, true, false],
              }],
              [{
                text: `Tarjouksen tekijä on tietoinen, että mikäli kaupan kohteen hallinnan luovutus viivästyy viranomaismääräysten tai -ohjeistusten vuoksi, kyseessä ei ole myyjän suoritusvirhe ja tarjouksen tekijä ei tällöin ole oikeutettu korvauksiin hallinnan luovutuksen viivästymisen vuoksi.

                  Osapuolet ovat tietoisia myös siitä, että mikäli kaupantekotilaisuutta ei pystytä järjestämään viranomaismääräysten tai
                  -ohjeistusten vuoksi (pankki, välittäjä, ostaja, myyjä) ostotarjouksessa sovitussa ajassa vaan se siirtyy myöhempään ajankohtaan, ei tarjouksessa sovittua sanktiota noudateta.
                  
                  Osapuolet ovat tietoisia, että mikäli kaupat toteutetaan sähköisesti voi kaupankäyntijärjestelmien käytöstä aiheutua kustannuksia.`,
                fontSize: 8,
                margin: [0, 10, 5, 10],
                border: [true, false, true, true],
              }],
            ],
          },
          layout: greyBorders(),
          margin: [0, 10, 0, 5],
          fontSize: 6.5,
        });

        // VALTION ETUOSTO
        if (this.governmentRight) {
          this.pdfContent.push({
            unbreakable: true,
            table: {
              body: [
                [{
                  text: 'VALTION ETUOSTO-OIKEUS',
                  margin: [0, 3, 0, -2],
                  fontSize: 8.5,
                  color: textColor,
                  border: [true, true, true, false],
                }],
                [{
                  text: 'Ostaja on tietoinen siitä, että valtiolla on etuosto-oikeus kiinteistön kaupassa, jos kiinteistön hankkiminen on tarpeen maanpuolustuksen, rajavalvonnan tai rajaturvallisuuden varmistamiseksi taikka alueellisen koskemattomuuden valvonnan ja turvaamisen takia.',
                  fontSize: 8,
                  margin: [0, 10, 5, 10],
                  border: [true, false, true, true],
                }],
              ],
            },
            layout: greyBorders(),
            margin: [0, 10, 0, 5],
            fontSize: 6.5,
          });
        }

        // eslint-disable-next-line
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.fonts = {
          Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf',
          },
          Icons: {
            normal: 'NewIcons.ttf',
          },
        };
        // eslint-disable-next-line
        const docDefinition = {
          content: this.pdfContent,
          footer: (currentPage, pageCount) => ({
            color: '#666666',
            text: `${this.footerText}  Sivu: ${currentPage.toString()} / ${pageCount}`,
            fontSize: 8,
            alignment: 'right',
            width: '50%',
            margin: [0, 0, 17, 3],
          }),
          defaultStyle: {
            font: 'Roboto',
          },
          pageMargins: [15, 20, 15, 24],
          styles: {
            grayLines: {
              hLineColor: () => 'gray',
              vLineColor: () => 'gray',
            },
          },
        };

        if (load === false && !this.agent) {
          const doc = pdfMake.createPdf(docDefinition);
          // const f = document.getElementById('pdfPreview');
          const callback = (url) => {
            // this.pdfDataUrl = url;
            this.pdfDataUrl = pdf.createLoadingTask(url);
            this.pdfDataUrl.promise.then((pdf2) => {
              this.numPages = pdf2.numPages;
              this.showPreview = true;
            });
            // this.!!pdfDataUrl = atob(url);
            // f.setAttribute('src', url);
          };
          doc.getDataUrl(callback, doc);
        } else if (load) {
          pdfMake.createPdf(docDefinition).download('ostotarjous.pdf');
        }
      } catch (e) {
        console.warn(e);
      }
    },
    pdfTable(title, value, colSpan, rowSpan = 1, small = false) {
      return {
        table: {
          widths: ['*'],
          body: [
            [{
              text: title,
              fontSize: 7,
              margin: [0, 0, 0, 0],
              color: '#666666',
            }],
            [{ text: value, fontSize: small ? 5.5 : 9, margin: [0, -3, 0, 0] }],
          ],
        },
        rowSpan,
        colSpan,
        layout: 'noBorders',
        margin: [0, -2, 0, -2],
      };
    },
    pepTable(value, description) {
      return {
        table: {
          widths: [25, 25, '*'],
          body: [
            [{
              text: 'Olen tai olen ollut viimeisen vuoden aikana poliittisesti vaikutusvaltainen henkilö, tällaisen henkilön perheenjäsen tai läheinen yhtiökumppani',
              fontSize: 7,
              margin: [-5, 3, 0, 2],
              color: '#666666',
              colSpan: 3,
            },
            '',
            '',
            ],
            [
              this.checkBox(value === false ? 'X' : ' ', 'Ei', 1, false, true, true),
              this.checkBox(value === true ? 'X' : ' ', 'Kyllä', 1, false, true, true),
              { text: value === true ? description : ' ', fontSize: 9, margin: [0, -3, 0, 0] },
            ],
          ],
        },
        colSpan: 4,
        layout: 'noBorders',
        margin: [5, -2, 0, -5],
      };
    },
    async logout() {
      this.thanksForSigning = false;
      await apiGet('authorization/logout');
      this.setAuthorization(false);
      this.setAgent(false);
      this.edit = true;
    },
    formatDate(date) {
      if (!date) return ' ';
      return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
    countDeposit() {
      if (this.form.offer > 0) {
        if (this.isShare) {
          this.form.depositInEuros = (parseFloat(this.form.offer) - parseFloat(this.form.debt))
            * 0.04;
        } else {
          this.form.depositInEuros = parseFloat(this.form.offer) * 0.10;
        }
        this.form.depositInEuros = this.form.depositInEuros.toFixed(2);
      }
    },
    async getProperty() {
      const response = await apiGet(`properties/property/${this.$route.params.id}`);
      this.property = response.result;
      this.setCompanyName(this.property.companyName);
      if (this.property.velkaosuus > 0) {
        this.debtPortion = 1;
      }
      this.form.debt = this.property.velkaosuus.replace('.', ',');
      if (this.property.isannoitsijapvm && this.property.isannoitsijapvm !== '0000-00-00') {
        this.form.debtDate = this.property.isannoitsijapvm;
      }
      this.countDeposit();
    },
    async getSellers() {
      const response = await apiGet(`properties/sellers/${this.$route.params.id}`);
      if (response.success) {
        let i = 0;
        response.result.forEach((seller) => {
          if (!this.currentIndexSignatures.some(s => s.offerer_index === i.toString())) {
            seller.send = true; // eslint-disable-line
          } else {
            seller.send = false; // eslint-disable-line
          }
          i += 1;
        });
        this.sellers = response.result;
        return response.result;
      }
      return false;
    },
    async pollOffer() {
      const response = await apiGet(`properties/poll/${this.$route.params.offerId}`);
      if (response.result === 'false') {
        this.expired = true;
      }
    },
    async getOffer() {
      const response = await apiGet(`properties/offer/${this.$route.params.offerId}`);
      if (response.result.status) {
        this.form.status = response.result.status;
      }
      if (this.cannotEdit) this.edit = false;

      if (response.result.status === 'new' || response.result.status === 'fill') {
        this.sendable = true;
      }

      if (response.success !== 'false' && response.result.status === 'new') {
        this.form.offerers = JSON.parse(response.result.offerers);
      }

      if (response.success !== 'false' && response.result.fields) {
        const offer = JSON.parse(response.result.fields);
        this.offererName = response.result.offerName || '';
        this.offererEmail = response.result.offerEmail || '';
        this.offerSignedDate = response.result.offerSignedDate ? this.formatDateTime(response.result.offerSignedDate) : ' ';
        this.signingAgent = response.result.agentName || ' ';
        this.companyId = +response.result.yritysid;
        const offerKeys = Object.keys(offer);
        offerKeys.forEach((key) => {
          // this.form[key] = offer[key];
          if (key !== 'status') {
            Vue.set(this.form, key, offer[key]);
          }
        });
        this.fieldsExist = true;
        this.createDate = response.result.createDate;
        await this.getOfferResponses();
        if (this.agent) {
          await this.getCurrentIndexSignatures();
        }
        await this.setSendStatusesForOfferer();
        const sellers = await this.getSellers();

        if (response.result.status) {
          if (response.result.status === 'sellerresponse') {
            this.setSignerRole('offerer');
            this.setSigners(_.cloneDeep(this.form.offerers));
          } else {
            this.setSignerRole('seller');
            this.setSigners(_.cloneDeep(sellers));
          }
        }

        if (this.form.responseOffer) {
          this.setResponseOffer(this.form.responseOffer);
        }
      } else {
        this.fieldsExist = false;
      }
    },
    async setSendStatusesForOfferer() {
      if (this.responses.length) {
        let index = 0;
        this.form.offerers.forEach((offerer) => {
          if (!this.responseSignatureExists(index)) {
            offerer.send = true; // eslint-disable-line
          } else {
            offerer.send = false; // eslint-disable-line
          }
          offerer.signature = false; // eslint-disable-line
          index += 1;
        });
      } else {
        this.form.offerers.forEach((offerer) => {
          if (!this.signatures.some(s => s.ssn === offerer.ssn)) {
            offerer.send = true; // eslint-disable-line
          } else {
            offerer.send = false; // eslint-disable-line
          }
          offerer.signature = false; // eslint-disable-line
        });
      }
    },
    async getOfferLog() {
      const response = await apiGet(`properties/log/${this.$route.params.offerId}`);
      this.log = response.result;
    },
    async submitCode() {
      this.loadingThings = true;
      this.authorizing = true;
      try {
        await apiPost('authorization', {
          propertyId: this.$route.params.id,
          offerId: this.$route.params.offerId,
          passCode: this.passCode,
        });
        const authorization = await apiGet(`authorization/property/${this.$route.params.id}/${this.$route.params.offerId}`);
        if (authorization.success) {
          this.setAuthorization(JSON.parse(authorization.result.isAuthorized));
          if (authorization.result.signerEmail) {
            this.setCurrentSigner({
              name: authorization.result.signerName,
              email: authorization.result.signerEmail,
              participantIndex: authorization.result.participantIndex,
            });
          }
          await this.getProperty();
          await this.getSignatures();
          await this.getOffer();
          await this.getOfferLog();
        } else {
          this.setAuthorization(false);
          this.setCurrentSigner({});
        }
      } catch (e) {
        console.warn(e);
      }
      this.loadingThings = false;
      this.authorizing = false;
    },
    async offerFilled() {
      await apiGet(`properties/offerfilled/${this.$route.params.offerId}`);
    },
    async saveOffer(preventLogout = false, preventStatusChange = true) {
      this.snackbar = true;

      let nextStatuses = {
        fill: 'filled',
        agreement: 'decision',
      };

      if (preventLogout && preventStatusChange) {
        nextStatuses = {
          fill: 'fill',
          agreement: 'agreement',
        };
      }

      if (preventLogout === false && this.agent === false) {
        // keep the status if only saving changes
        this.thankYouRole = this.status === 'agreement' ? 'seller' : 'offerer';
        this.thankyou = true;
      }

      if (this.form.status in nextStatuses) {
        const fields = {
          offer: this.form.offer,
          debtPortion: this.form.debtPortion,
          debtPortionPayer: this.form.debtPortionPayer,
          expenseDetail: this.form.expenseDetail,
          riskDetail: this.form.riskDetail,
          paymentMethod: this.form.paymentMethod,
          paymentDetail: this.form.paymentDetail,
          paymentDelay: this.form.paymentDelay,
          paymentDate: this.form.paymentDate,
          paymentOther: this.form.paymentOther,
          ownershipTransfer: this.form.ownershipTransfer,
          ownershipTransferDetail: this.form.ownershipTransferDetail,
          possessionTransfer: this.form.possessionTransfer,
          possessionTransferDetail: this.form.possessionTransferDetail,
          debt: this.form.debt,
          expense: this.form.expense,
          risk: this.form.risk,
          conditions: this.form.conditions,
          expenseDate: this.form.expenseDate,
          deposit: this.form.deposit,
          depositInEuros: this.form.depositInEuros,
          otherConditions: this.form.otherConditions,
          offerers: this.form.offerers,
          offerValidUntilDate: this.form.offerValidUntilDate,
          offerValidUntilTime: this.form.offerValidUntilTime,
          signingDate: this.form.signingDate,
          exceptions: this.exceptions,
          responseOffer: this.responseOffer,
          selectedAttachments: this.form.selectedAttachments,
          status: nextStatuses[this.form.status],
          signers: this.form.signers,
          responder: 'seller',
        };

        if (this.form.offerers.filter(offerer => offerer.signature === true)) {
          const offerers = this.form.offerers.filter(offerer => offerer.signature === true);
          if (offerers.length) {
            const signedOfferers = [];
            offerers.forEach((offerer) => {
              signedOfferers.push({ name: offerer.name });
            });
            fields.signers = signedOfferers;
          }
        } else {
          fields.signers = this.form.signers;
        }

        await apiPut(`properties/offer/${this.$route.params.offerId}`, {
          fields,
        });
      } else {
        const fields = {
          offer: this.form.offer,
          debtPortion: this.form.debtPortion,
          debtPortionPayer: this.form.debtPortionPayer,
          expenseDetail: this.form.expenseDetail,
          riskDetail: this.form.riskDetail,
          paymentMethod: this.form.paymentMethod,
          paymentDetail: this.form.paymentDetail,
          paymentDelay: this.form.paymentDelay,
          paymentDate: this.form.paymentDate,
          paymentOther: this.form.paymentOther,
          ownershipTransfer: this.form.ownershipTransfer,
          ownershipTransferDetail: this.form.ownershipTransferDetail,
          possessionTransfer: this.form.possessionTransfer,
          possessionTransferDetail: this.form.possessionTransferDetail,
          debt: this.form.debt,
          expense: this.form.expense,
          risk: this.form.risk,
          conditions: this.form.conditions,
          expenseDate: this.form.expenseDate,
          deposit: this.form.deposit,
          depositInEuros: this.form.depositInEuros,
          otherConditions: this.form.otherConditions,
          selectedAttachments: this.form.selectedAttachments,
          offerers: this.form.offerers,
          offerValidUntilDate: this.form.offerValidUntilDate,
          offerValidUntilTime: this.form.offerValidUntilTime,
          signingDate: this.form.signingDate,
          signers: this.form.signers,
          responder: 'seller',
        };
        await apiPut(`properties/offer/${this.$route.params.offerId}`, {
          fields,
        });
      }
      if (preventLogout === false) {
        if (this.agent === false) {
          await this.logout();
          return;
        }
      }
      await this.getOfferLog();
      await this.getOffer();
      this.saveDialog = false;
      this.userHasEdited = false;
    },
    async sendNow() {
      this.sending = true;
      await apiPost(`properties/updateoffereremails/${this.$route.params.offerId}`, this.form.offerers);
      const response = await apiPost('properties/send', {
        offerers: this.form.offerers,
        responseOffer: this.form.status === 'sellerresponse' ? 'true' : 'false',
      });
      if (response.success) {
        this.sendToOfferer = false;
        this.linkSnackBar = true;
      }
      await this.getOffer();
      await this.getOfferLog();
      this.sending = false;
    },

    async sendToBothAction() {
      this.sending = true;
      const response = await apiPost('properties/sendtoboth', {
        offerers: this.form.offerers,
        sellers: this.sellers,
        status: this.form.status,
      });
      if (response.success) {
        this.sendToBoth = false;
        this.linkSnackBar = true;
      }
      await this.getOffer();
      await this.getOfferLog();
      this.sending = false;
      this.closeOfferDialogOpen();
    },

    async sendToSellerAction() {
      this.sending = true;
      const response = await apiPost('properties/sendtoseller', {
        sellers: this.sellers,
      });
      if (response.success) {
        this.sendToSeller = false;
        this.linkSnackBar = true;
      }
      await this.getOfferLog();
      await this.getOffer();
      this.sending = false;
    },
  },
};
</script>

<style>
  .grid {
    display: grid;
    justify-content: stretch;
  }

  .grid-actions {
    grid-template-columns: 1fr 120px;
  }

  .grid-actions .v-btn {
    grid-column-start: 2;
  }

  #pdfV {
    width: 100%;
    height: 1000px;
  }

  .v-expansion-panel-header--active {
    border-bottom: 1px #eee solid;
  }

  .green .v-expansion-panel-header {
    background: #4CAF50;
    color: #FFF;
  }

  .warn .v-expansion-panel-header {
    background: #FFA000;
    color: #FFF;
  }

  .red .v-expansion-panel-header {
    background: #F4511E;
    color: #FFF;
  }

  .v-input--radio-group__input .v-label, .v-input--checkbox .v-label {
    font-size: 12px;
  }

  .v-text-field .v-label {
    background: #fff;
    padding-right: 4px;
  }

  .v-stepper__step {
    border: 1px #eee solid;
    border-radius: 4px;
    background: #FFF;
  }
  .v-stepper__step:HOVER {
    background: #eee !important;
  }

.v-list--three-line
  .v-list-item .v-list-item__subtitle, .v-list-item--three-line .v-list-item__subtitle {
  -webkit-line-clamp: unset;
}

#pdfPreview {
  width: 100%;
}
</style>
